import { splitSetPhrase } from "../../shared/setPhrase";
// Every English One Piece print, generated from onepiece.limitlesstcg.com.
//
// There is no One Piece card API and no price API, so the catalogue ships with
// the app instead of being fetched. That also means One Piece search costs no
// API credits and works with no connection - only the card art needs the net.
//
// Rows are [id, name, rarity], kept as tuples rather than objects because at
// this size the key repetition would triple the file.
const ROWS = [
["EB01-001","Kouzuki Oden","Leader"],
["EB01-002","Izo","Rare"],
["EB01-003","Kid & Killer","Rare"],
["EB01-004","Koza","Common"],
["EB01-005","Doma","Common"],
["EB01-006","Tony Tony.Chopper","Super Rare"],
["EB01-007","Yamato","Common"],
["EB01-008","LittleOars Jr.","Rare"],
["EB01-009","Just Shut Up and Come with Us!!!!","Common"],
["EB01-010","There's No Way You Could Defeat Me!!","Rare"],
["EB01-011","Mini-Merry","Common"],
["EB01-012","Cavendish","Super Rare"],
["EB01-013","Kouzuki Hiyori","Rare"],
["EB01-014","Sanji","Rare"],
["EB01-015","Scratchmen Apoo","Rare"],
["EB01-016","Bingoh","Common"],
["EB01-017","Blueno","Common"],
["EB01-018","Mountain God","Common"],
["EB01-019","Off-White","Rare"],
["EB01-020","Chambres","Common"],
["EB01-021","Hannyabal","Leader"],
["EB01-022","Inazuma","Super Rare"],
["EB01-023","Edward Weevil","Rare"],
["EB01-024","Hamlet","Common"],
["EB01-025","Fourtricks","Common"],
["EB01-026","Prince Bellett","Common"],
["EB01-027","Mr.1(Daz.Bonez)","Rare"],
["EB01-028","Gum-Gum Champion Rifle","Rare"],
["EB01-029","Sorry. I'm a Goner.","Common"],
["EB01-030","Loguetown","Common"],
["EB01-031","Kalifa","Rare"],
["EB01-032","Army Wolves","Common"],
["EB01-033","Blueno","Rare"],
["EB01-034","Ms. Wednesday","Super Rare"],
["EB01-035","Ms. Monday","Common"],
["EB01-036","Minochihuahua","Common"],
["EB01-037","Mr. 9","Common"],
["EB01-038","Oh Come My Way","Common"],
["EB01-039","Conquerer of Three Worlds Ragnaraku","Rare"],
["EB01-040","Kyros","Leader"],
["EB01-041","Crocus","Common"],
["EB01-042","Scarlet","Rare"],
["EB01-043","Spandine","Rare"],
["EB01-044","Funkfreed","Common"],
["EB01-045","Brook","Common"],
["EB01-046","Brook","Super Rare"],
["EB01-047","Laboon","Common"],
["EB01-048","Laboon","Super Rare"],
["EB01-049","T-Bone","Rare"],
["EB01-050","...I Want to Live!!","Common"],
["EB01-051","Finger Pistol","Rare"],
["EB01-052","Viola","Super Rare"],
["EB01-053","Gastino","Common"],
["EB01-054","Gan.Fall","Rare"],
["EB01-055","Charlotte Compote","Common"],
["EB01-056","Charlotte Flampe","Rare"],
["EB01-057","Shirahoshi","Super Rare"],
["EB01-058","Mont Blanc Cricket","Common"],
["EB01-059","Kingdom Come","Rare"],
["EB01-060","Did Someone Say...Kami?","Common"],
["EB01-061","Mr.2.Bon.Kurei(Bentham)","Secret Rare"],
["EB01-003_p1","Kid & Killer",""],
["EB01-006_p1","Tony Tony.Chopper",""],
["EB01-012_p1","Cavendish",""],
["EB01-013_p1","Kouzuki Hiyori",""],
["EB01-022_p1","Inazuma",""],
["EB01-027_p1","Mr.1(Daz.Bonez)",""],
["EB01-031_p1","Kalifa",""],
["EB01-034_p1","Ms. Wednesday",""],
["EB01-046_p1","Brook",""],
["EB01-048_p1","Laboon",""],
["EB01-049_p1","T-Bone",""],
["EB01-052_p1","Viola",""],
["EB01-056_p1","Charlotte Flampe",""],
["EB01-057_p1","Shirahoshi",""],
["EB01-061_p1","Mr.2.Bon.Kurei(Bentham)",""],
["EB01-001_p1","Kouzuki Oden",""],
["EB01-021_p1","Hannyabal",""],
["EB01-040_p1","Kyros",""],
["EB01-006_p2","Tony Tony.Chopper",""],
["EB02-001","Karoo","Common"],
["EB02-002","Sabo","Rare"],
["EB02-003","Tony Tony.Chopper","Rare"],
["EB02-004","Don Accino","Common"],
["EB02-005","Fake Straw Hat Crew","Common"],
["EB02-006","Yamato","Super Rare"],
["EB02-007","Cloven Rose Blizzard","Common"],
["EB02-008","The Peak","Rare"],
["EB02-009","Thousand Sunny","Common"],
["EB02-010","Monkey.D.Luffy","Leader"],
["EB02-011","Arlong","Super Rare"],
["EB02-012","Gaimon","Common"],
["EB02-013","Carrot","Common"],
["EB02-014","Sarfunkel","Common"],
["EB02-015","Jewelry Bonney","Super Rare"],
["EB02-016","Chopperman","Common"],
["EB02-017","Nami","Rare"],
["EB02-018","Buggy","Rare"],
["EB02-019","Roronoa Zoro","Rare"],
["EB02-020","We Are!","Rare"],
["EB02-021","Gum-Gum Giant Pistol","Common"],
["EB02-022","Usopp","Rare"],
["EB02-023","Crocodile","Common"],
["EB02-024","Sogeking","Common"],
["EB02-025","Donquixote Rosinante","Rare"],
["EB02-026","Nefeltari Vivi","Super Rare"],
["EB02-027","Vista","Common"],
["EB02-028","Portgas.D.Ace","Rare"],
["EB02-029","Grandpa Ryu","Common"],
["EB02-030","And That's When Somebody Makes Fun of Their Friend's Dream!!!!","Common"],
["EB02-031","Hope","Rare"],
["EB02-032","Iceburg","Common"],
["EB02-033","Klabautermann","Common"],
["EB02-034","Komei","Common"],
["EB02-035","Sanji & Pudding","Super Rare"],
["EB02-036","Nico Robin","Rare"],
["EB02-037","Franky","Rare"],
["EB02-038","Magellan","Common"],
["EB02-039","GERMA 66","Common"],
["EB02-040","BRAND NEW WORLD","Rare"],
["EB02-041","Merry Go","Rare"],
["EB02-042","All-Hunt Grount","Common"],
["EB02-043","Jonathan","Common"],
["EB02-044","Sengoku","Super Rare"],
["EB02-045","Trafalgar Law","Super Rare"],
["EB02-046","Hildon","Common"],
["EB02-047","Blueno","Common"],
["EB02-048","Brook","Rare"],
["EB02-049","Monkey.D.Garp","Rare"],
["EB02-050","Kokoro no Chizu","Rare"],
["EB02-051","Three-Pace Hum Soul Notch Slash","Common"],
["EB02-052","Enel","Super Rare"],
["EB02-053","Myskina Olga","Common"],
["EB02-054","Sanji","Rare"],
["EB02-055","Jinbe","Rare"],
["EB02-056","Vegapunk","Super Rare"],
["EB02-057","Mad Treasure","Common"],
["EB02-058","UUUUUS!","Rare"],
["EB02-059","Without Your Help I Can't Become the King of the Pirates!!!!","Common"],
["EB02-060","Merry Go","Common"],
["EB02-061","Monkey.D.Luffy","Secret Rare"],
["EB02-003_p1","Tony Tony.Chopper",""],
["EB02-006_p1","Yamato",""],
["EB02-011_p1","Arlong",""],
["EB02-015_p1","Jewelry Bonney",""],
["EB02-017_p1","Nami",""],
["EB02-022_p1","Usopp",""],
["EB02-026_p1","Nefeltari Vivi",""],
["EB02-035_p1","Sanji & Pudding",""],
["EB02-036_p1","Nico Robin",""],
["EB02-044_p1","Sengoku",""],
["EB02-045_p1","Trafalgar Law",""],
["EB02-048_p1","Brook",""],
["EB02-052_p1","Enel",""],
["EB02-054_p1","Sanji",""],
["EB02-056_p1","Vegapunk",""],
["EB02-061_p1","Monkey.D.Luffy",""],
["EB02-010_p1","Monkey.D.Luffy",""],
["EB02-061_p2","Monkey.D.Luffy",""],
["OP05-001_p2","Sabo",""],
["OP05-002_p2","Belo Betty",""],
["OP05-022_p2","Donquixote Rosinante",""],
["OP05-060_p5","Monkey.D.Luffy",""],
["OP05-098_p3","Enel",""],
["OP06-001_p2","Uta",""],
["OP06-020_p2","Hody Jones",""],
["OP06-021_p2","Perona",""],
["OP06-022_p2","Yamato",""],
["OP06-042_p2","Vinsmoke Reiju",""],
["OP06-080_p2","Gecko Moria",""],
["EB01-001_p2","Kouzuki Oden",""],
["EB01-021_p2","Hannyabal",""],
["EB01-040_p2","Kyros",""],
["OP07-001_p2","Monkey.D.Dragon",""],
["OP07-019_p2","Jewelry Bonney",""],
["OP07-038_p2","Boa Hancock",""],
["OP07-059_p2","Foxy",""],
["OP07-079_p2","Rob Lucci",""],
["OP07-097_p2","Vegapunk",""],
["OP08-001_p2","Tony Tony.Chopper",""],
["OP08-002_p2","Marco",""],
["OP08-021_p2","Carrot",""],
["OP08-057_p2","King",""],
["OP08-058_p2","Charlotte Pudding",""],
["OP08-098_p2","Kalgara",""],
["EB03-001","Nefeltari Vivi","Leader"],
["EB03-002","Ain","Common"],
["EB03-003","Uta","Super Rare"],
["EB03-004","Carina","Common"],
["EB03-005","Sugar","Rare"],
["EB03-006","Nami","Rare"],
["EB03-007","Baccarat","Common"],
["EB03-008","Hibari","Rare"],
["EB03-009","Makino","Common"],
["EB03-010","Monet","Rare"],
["EB03-011","But If We Ever See Each Other Again... Will You Call Me Your Shipmate?!!","Common"],
["EB03-012","Otama","Rare"],
["EB03-013","Carrot","Rare"],
["EB03-014","Kuina","Common"],
["EB03-015","Camie","Common"],
["EB03-016","Kouzuki Hiyori","Common"],
["EB03-017","Jewelry Bonney","Rare"],
["EB03-018","Tashigi","Super Rare"],
["EB03-019","Wanda","Common"],
["EB03-020","There You Are, Sore Loser!","Common"],
["EB03-021","Alvida","Common"],
["EB03-022","Isuka","Rare"],
["EB03-023","Kaya","Common"],
["EB03-024","Nefeltari Vivi","Super Rare"],
["EB03-025","Hina","Rare"],
["EB03-026","Boa Hancock","Super Rare"],
["EB03-027","Marguerite","Rare"],
["EB03-028","Yu","Common"],
["EB03-029","Insolent Fool!! Stand Down!!","Common"],
["EB03-030","Viola","Common"],
["EB03-031","Vinsmoke Reiju","Super Rare"],
["EB03-032","Charlotte Flampe","Common"],
["EB03-033","Charlotte Brulee","Common"],
["EB03-034","Charlotte Linlin","Rare"],
["EB03-035","Charlotte Pudding","Rare"],
["EB03-036","Baby 5","Common"],
["EB03-037","Lim","Rare"],
["EB03-038","Thanks for the Treat. ♡","Common"],
["EB03-039","Ulti","Rare"],
["EB03-040","Kalifa","Common"],
["EB03-041","Kujyaku","Rare"],
["EB03-042","Koala","Super Rare"],
["EB03-043","Stussy","Rare"],
["EB03-044","Black Maria","Common"],
["EB03-045","Perona","Super Rare"],
["EB03-046","Miss Doublefinger(Zala)","Common"],
["EB03-047","Miss.Valentine(Mikita)","Common"],
["EB03-048","Rebecca","Rare"],
["EB03-049","I Knew You People Were Behind This.","Common"],
["EB03-050","Conis","Common"],
["EB03-051","Charlotte Smoothie","Common"],
["EB03-052","Shirahoshi","Rare"],
["EB03-053","Nami","Super Rare"],
["EB03-054","Nico Robin","Common"],
["EB03-055","Nico Robin","Super Rare"],
["EB03-056","Belo Betty","Common"],
["EB03-057","Yamato","Rare"],
["EB03-058","Lilith","Rare"],
["EB03-059","S-Snake","Rare"],
["EB03-060","Will You Be My Servant?","Common"],
["EB03-061","Uta","Secret Rare"],
["EB03-062","Trafalgar Law","Secret Rare"],
["EB03-003_p1","Uta",""],
["EB03-008_p1","Hibari",""],
["EB03-013_p1","Carrot",""],
["EB03-018_p1","Tashigi",""],
["EB03-024_p1","Nefeltari Vivi",""],
["EB03-025_p1","Hina",""],
["EB03-026_p1","Boa Hancock",""],
["EB03-031_p1","Vinsmoke Reiju",""],
["EB03-034_p1","Charlotte Linlin",""],
["EB03-041_p1","Kujyaku",""],
["EB03-042_p1","Koala",""],
["EB03-045_p1","Perona",""],
["EB03-053_p1","Nami",""],
["EB03-055_p1","Nico Robin",""],
["EB03-057_p1","Yamato",""],
["EB03-061_p1","Uta",""],
["EB03-062_p1","Trafalgar Law",""],
["EB03-001_p1","Nefeltari Vivi",""],
["EB03-061_p2","Uta",""],
["EB03-003_p2","Uta","Special Card"],
["EB03-018_p2","Tashigi","Special Card"],
["EB03-024_p2","Nefeltari Vivi","Special Card"],
["EB03-026_p2","Boa Hancock","Special Card"],
["EB03-031_p2","Vinsmoke Reiju","Special Card"],
["EB03-042_p2","Koala","Special Card"],
["EB03-045_p2","Perona","Special Card"],
["EB03-053_p2","Nami","Special Card"],
["EB03-055_p2","Nico Robin","Special Card"],
["OP01-001","Roronoa Zoro","Leader"],
["OP01-002","Trafalgar Law","Leader"],
["OP01-003","Monkey.D.Luffy","Leader"],
["OP01-004","Usopp","Rare"],
["OP01-005","Uta","Rare"],
["OP01-006","Otama","Uncommon"],
["OP01-007","Caribou","Common"],
["OP01-008","Cavendish","Common"],
["OP01-009","Carrot","Common"],
["OP01-010","Komachiyo","Common"],
["OP01-011","Gordon","Uncommon"],
["OP01-012","Sai","Common"],
["OP01-013","Sanji","Rare"],
["OP01-014","Jinbe","Uncommon"],
["OP01-015","Tony Tony.Chopper","Uncommon"],
["OP01-016","Nami","Rare"],
["OP01-017","Nico Robin","Rare"],
["OP01-018","Hajrudin","Common"],
["OP01-019","Bartolomeo","Common"],
["OP01-020","Hyogoro","Common"],
["OP01-021","Franky","Uncommon"],
["OP01-022","Brook","Uncommon"],
["OP01-023","Marco","Common"],
["OP01-024","Monkey.D.Luffy","Super Rare"],
["OP01-025","Roronoa Zoro","Super Rare"],
["OP01-026","Gum-Gum Fire-Fist Pistol Red Hawk","Rare"],
["OP01-027","Round Table","Common"],
["OP01-028","Green Star Rafflesia","Common"],
["OP01-029","Radical Beam!!","Uncommon"],
["OP01-030","In Two Years!! At the Sabaody Archipelago!!","Uncommon"],
["OP01-031","Kouzuki Oden","Leader"],
["OP01-032","Ashura Doji","Uncommon"],
["OP01-033","Izo","Uncommon"],
["OP01-034","Inuarashi","Common"],
["OP01-035","Okiku","Rare"],
["OP01-036","Otsuru","Common"],
["OP01-037","Kawamatsu","Common"],
["OP01-038","Kanjuro","Common"],
["OP01-039","Killer","Uncommon"],
["OP01-040","Kin'emon","Super Rare"],
["OP01-041","Kouzuki Momonosuke","Rare"],
["OP01-042","Komurasaki","Uncommon"],
["OP01-043","Shinobu","Common"],
["OP01-044","Shachi","Common"],
["OP01-045","Jean Bart","Common"],
["OP01-046","Denjiro","Rare"],
["OP01-047","Trafalgar Law","Super Rare"],
["OP01-048","Nekomamushi","Common"],
["OP01-049","Bepo","Rare"],
["OP01-050","Penguin","Common"],
["OP01-051","Eustass\"Captain\"Kid","Super Rare"],
["OP01-052","Raizo","Uncommon"],
["OP01-053","Wire","Common"],
["OP01-054","X.Drake","Rare"],
["OP01-055","You Can Be My Samurai!!","Common"],
["OP01-056","Demon Face","Uncommon"],
["OP01-057","Paradise Waterfall","Uncommon"],
["OP01-058","Punk Gibson","Rare"],
["OP01-059","BE-BENG!!","Common"],
["OP01-060","Donquixote Doflamingo","Leader"],
["OP01-061","Kaido","Leader"],
["OP01-062","Crocodile","Leader"],
["OP01-063","Arlong","Uncommon"],
["OP01-064","Alvida","Common"],
["OP01-065","Vergo","Common"],
["OP01-066","Krieg","Common"],
["OP01-067","Crocodile","Super Rare"],
["OP01-068","Gecko Moria","Rare"],
["OP01-069","Caesar Clown","Rare"],
["OP01-070","Dracule Mihawk","Super Rare"],
["OP01-071","Jinbe","Rare"],
["OP01-072","Smiley","Common"],
["OP01-073","Donquixote Doflamingo","Rare"],
["OP01-074","Bartholomew Kuma","Rare"],
["OP01-075","Pacifista","Common"],
["OP01-076","Bellamy","Common"],
["OP01-077","Perona","Uncommon"],
["OP01-078","Boa Hancock","Super Rare"],
["OP01-079","Ms. All Sunday","Rare"],
["OP01-080","Miss Doublefinger(Zala)","Common"],
["OP01-081","Mocha","Common"],
["OP01-082","Monet","Common"],
["OP01-083","Mr.1(Daz.Bonez)","Uncommon"],
["OP01-084","Mr.2.Bon.Kurei(Bentham)","Uncommon"],
["OP01-085","Mr.3(Galdino)","Uncommon"],
["OP01-086","Overheat","Rare"],
["OP01-087","Officer Agents","Common"],
["OP01-088","Desert Spada","Uncommon"],
["OP01-089","Crescent Cutlass","Common"],
["OP01-090","Baroque Works","Uncommon"],
["OP01-091","King","Leader"],
["OP01-092","Urashima","Common"],
["OP01-093","Ulti","Rare"],
["OP01-094","Kaido","Super Rare"],
["OP01-095","Kyoshirou","Uncommon"],
["OP01-096","King","Super Rare"],
["OP01-097","Queen","Rare"],
["OP01-098","Kurozumi Orochi","Uncommon"],
["OP01-099","Kurozumi Semimaru","Common"],
["OP01-100","Kurozumi Higurashi","Common"],
["OP01-101","Sasaki","Uncommon"],
["OP01-102","Jack","Rare"],
["OP01-103","Scratchmen Apoo","Common"],
["OP01-104","Speed","Common"],
["OP01-105","Bao Huang","Common"],
["OP01-106","Basil Hawkins","Uncommon"],
["OP01-107","Babanuki","Common"],
["OP01-108","Hitokiri Kamazo","Uncommon"],
["OP01-109","Who's.Who","Uncommon"],
["OP01-110","Fukurokuju","Common"],
["OP01-111","Black Maria","Rare"],
["OP01-112","Page One","Rare"],
["OP01-113","Holedem","Common"],
["OP01-114","X.Drake","Rare"],
["OP01-115","Elephant's Marchoo","Common"],
["OP01-116","Artificial Devil Fruit SMILE","Uncommon"],
["OP01-117","Sheep's Horn","Common"],
["OP01-118","Ulti-Mortar","Uncommon"],
["OP01-119","Thunder Bagua","Rare"],
["OP01-120","Shanks","Secret Rare"],
["OP01-121","Yamato","Secret Rare"],
["OP01-013_p1","Sanji",""],
["OP01-016_p1","Nami",""],
["OP01-024_p1","Monkey.D.Luffy",""],
["OP01-025_p1","Roronoa Zoro",""],
["OP01-040_p1","Kin'emon",""],
["OP01-047_p1","Trafalgar Law",""],
["OP01-051_p1","Eustass\"Captain\"Kid",""],
["OP01-067_p1","Crocodile",""],
["OP01-070_p1","Dracule Mihawk",""],
["OP01-073_p1","Donquixote Doflamingo",""],
["OP01-078_p1","Boa Hancock",""],
["OP01-093_p1","Ulti",""],
["OP01-094_p1","Kaido",""],
["OP01-096_p1","King",""],
["OP01-097_p1","Queen",""],
["OP01-102_p1","Jack",""],
["OP01-120_p1","Shanks",""],
["OP01-121_p1","Yamato",""],
["OP01-001_p1","Roronoa Zoro",""],
["OP01-002_p1","Trafalgar Law",""],
["OP01-003_p1","Monkey.D.Luffy",""],
["OP01-031_p1","Kouzuki Oden",""],
["OP01-060_p1","Donquixote Doflamingo",""],
["OP01-061_p1","Kaido",""],
["OP01-062_p1","Crocodile",""],
["OP01-091_p1","King",""],
["OP01-120_p2","Shanks",""],
["OP01-008_p1","Cavendish",""],
["OP01-034_p1","Inuarashi",""],
["OP01-048_p1","Nekomamushi",""],
["OP01-064_p1","Alvida",""],
["OP01-077_p1","Perona",""],
["OP01-109_p1","Who's.Who",""],
["OP02-001","Edward.Newgate","Leader"],
["OP02-002","Monkey.D.Garp","Leader"],
["OP02-003","Atmos","Common"],
["OP02-004","Edward.Newgate","Super Rare"],
["OP02-005","Curly.Dadan","Uncommon"],
["OP02-006","Kingdew","Common"],
["OP02-007","Thatch","Common"],
["OP02-008","Jozu","Rare"],
["OP02-009","Squard","Uncommon"],
["OP02-010","Dogura","Common"],
["OP02-011","Vista","Rare"],
["OP02-012","Blenheim","Common"],
["OP02-013","Portgas.D.Ace","Super Rare"],
["OP02-014","Whitey Bay","Uncommon"],
["OP02-015","Makino","Uncommon"],
["OP02-016","Magura","Common"],
["OP02-017","Masked Deuce","Rare"],
["OP02-018","Marco","Rare"],
["OP02-019","Rakuyo","Uncommon"],
["OP02-020","LittleOars Jr.","Common"],
["OP02-021","Seaquake","Rare"],
["OP02-022","Whitebeard Pirates","Uncommon"],
["OP02-023","You May Be a Fool...but I Still Love You","Common"],
["OP02-024","Moby Dick","Common"],
["OP02-025","Kin'emon","Leader"],
["OP02-026","Sanji","Leader"],
["OP02-027","Inuarashi","Uncommon"],
["OP02-028","Usopp","Common"],
["OP02-029","Carrot","Rare"],
["OP02-030","Kouzuki Oden","Super Rare"],
["OP02-031","Kouzuki Toki","Uncommon"],
["OP02-032","Shishilian","Uncommon"],
["OP02-033","Jinbe","Common"],
["OP02-034","Tony Tony.Chopper","Uncommon"],
["OP02-035","Trafalgar Law","Common"],
["OP02-036","Nami","Super Rare"],
["OP02-037","Nico Robin","Uncommon"],
["OP02-038","Nekomamushi","Common"],
["OP02-039","Franky","Common"],
["OP02-040","Brook","Rare"],
["OP02-041","Monkey.D.Luffy","Rare"],
["OP02-042","Yamato","Rare"],
["OP02-043","Roronoa Zoro","Common"],
["OP02-044","Wanda","Common"],
["OP02-045","Three Sword Style Oni Giri","Common"],
["OP02-046","Diable Jambe Venaison Shoot","Uncommon"],
["OP02-047","Paradise Totsuka","Rare"],
["OP02-048","Land of Wano","Common"],
["OP02-049","Emporio.Ivankov","Leader"],
["OP02-050","Inazuma","Rare"],
["OP02-051","Emporio.Ivankov","Super Rare"],
["OP02-052","Cabaji","Common"],
["OP02-053","Crocodile","Common"],
["OP02-054","Gecko Moria","Common"],
["OP02-055","Dracule Mihawk","Common"],
["OP02-056","Donquixote Doflamingo","Uncommon"],
["OP02-057","Bartholomew Kuma","Uncommon"],
["OP02-058","Buggy","Rare"],
["OP02-059","Boa Hancock","Uncommon"],
["OP02-060","Mohji","Common"],
["OP02-061","Morley","Uncommon"],
["OP02-062","Monkey.D.Luffy","Super Rare"],
["OP02-063","Mr.1(Daz.Bonez)","Uncommon"],
["OP02-064","Mr.2.Bon.Kurei(Bentham)","Rare"],
["OP02-065","Mr.3(Galdino)","Rare"],
["OP02-066","Impel Down All Stars","Common"],
["OP02-067","Arabesque Brick Fist","Uncommon"],
["OP02-068","Gum-Gum Rain","Rare"],
["OP02-069","DEATH WINK","Common"],
["OP02-070","New Kama Land","Common"],
["OP02-071","Magellan","Leader"],
["OP02-072","Zephyr","Leader"],
["OP02-073","Little Sadi","Rare"],
["OP02-074","Saldeath","Common"],
["OP02-075","Shiki","Rare"],
["OP02-076","Shiryu","Rare"],
["OP02-077","Solitaire","Common"],
["OP02-078","Daifugo","Uncommon"],
["OP02-079","Douglas Bullet","Uncommon"],
["OP02-080","Dobon","Common"],
["OP02-081","Domino","Common"],
["OP02-082","Byrnndi World","Uncommon"],
["OP02-083","Hannyabal","Rare"],
["OP02-084","Blugori","Common"],
["OP02-085","Magellan","Super Rare"],
["OP02-086","Minokoala","Uncommon"],
["OP02-087","Minotaur","Uncommon"],
["OP02-088","Sphinx","Common"],
["OP02-089","Judgment of Hell","Rare"],
["OP02-090","Hydra","Uncommon"],
["OP02-091","Venom Road","Common"],
["OP02-092","Impel Down","Common"],
["OP02-093","Smoker","Leader"],
["OP02-094","Isuka","Uncommon"],
["OP02-095","Onigumo","Uncommon"],
["OP02-096","Kuzan","Super Rare"],
["OP02-097","Komille","Common"],
["OP02-098","Koby","Rare"],
["OP02-099","Sakazuki","Super Rare"],
["OP02-100","Jango","Common"],
["OP02-101","Strawberry","Common"],
["OP02-102","Smoker","Rare"],
["OP02-103","Sengoku","Rare"],
["OP02-104","Sentomaru","Common"],
["OP02-105","Tashigi","Common"],
["OP02-106","Tsuru","Uncommon"],
["OP02-107","Doberman","Common"],
["OP02-108","Donquixote Rosinante","Common"],
["OP02-109","Jaguar.D.Saul","Common"],
["OP02-110","Hina","Rare"],
["OP02-111","Fullbody","Common"],
["OP02-112","Bell-mère","Uncommon"],
["OP02-113","Helmeppo","Uncommon"],
["OP02-114","Borsalino","Super Rare"],
["OP02-115","Monkey.D.Garp","Rare"],
["OP02-116","Yamakaji","Common"],
["OP02-117","Ice Age","Uncommon"],
["OP02-118","Yasakani Sacred Jewel","Common"],
["OP02-119","Meteor Volcano","Rare"],
["OP02-120","Uta","Secret Rare"],
["OP02-121","Kuzan","Secret Rare"],
["OP02-004_p1","Edward.Newgate",""],
["OP02-013_p1","Portgas.D.Ace",""],
["OP02-017_p1","Masked Deuce",""],
["OP02-018_p1","Marco",""],
["OP02-030_p1","Kouzuki Oden",""],
["OP02-036_p1","Nami",""],
["OP02-041_p1","Monkey.D.Luffy",""],
["OP02-051_p1","Emporio.Ivankov",""],
["OP02-058_p1","Buggy",""],
["OP02-062_p1","Monkey.D.Luffy",""],
["OP02-073_p1","Little Sadi",""],
["OP02-085_p1","Magellan",""],
["OP02-096_p1","Kuzan",""],
["OP02-099_p1","Sakazuki",""],
["OP02-114_p1","Borsalino",""],
["OP02-115_p1","Monkey.D.Garp",""],
["OP02-120_p1","Uta",""],
["OP02-121_p1","Kuzan",""],
["OP02-001_p1","Edward.Newgate",""],
["OP02-002_p1","Monkey.D.Garp",""],
["OP02-025_p1","Kin'emon",""],
["OP02-026_p1","Sanji",""],
["OP02-049_p1","Emporio.Ivankov",""],
["OP02-071_p1","Magellan",""],
["OP02-072_p1","Zephyr",""],
["OP02-093_p1","Smoker",""],
["OP02-013_p2","Portgas.D.Ace",""],
["OP02-009_p1","Squard",""],
["OP02-031_p1","Kouzuki Toki",""],
["OP02-059_p1","Boa Hancock",""],
["OP02-086_p1","Minokoala",""],
["OP02-105_p1","Tashigi",""],
["OP02-108_p1","Donquixote Rosinante",""],
["OP03-001","Portgas.D.Ace","Leader"],
["OP03-002","Adio","Uncommon"],
["OP03-003","Izo","Rare"],
["OP03-004","Curiel","Common"],
["OP03-005","Thatch","Uncommon"],
["OP03-006","Speed Jil","Common"],
["OP03-007","Namule","Common"],
["OP03-008","Buggy","Uncommon"],
["OP03-009","Haruta","Common"],
["OP03-010","Fossa","Common"],
["OP03-011","Blamenco","Uncommon"],
["OP03-012","Marshall.D.Teach","Rare"],
["OP03-013","Marco","Super Rare"],
["OP03-014","Monkey.D.Garp","Uncommon"],
["OP03-015","Lim","Uncommon"],
["OP03-016","Flame Emperor","Rare"],
["OP03-017","Cross Fire","Uncommon"],
["OP03-018","Fire Fist","Rare"],
["OP03-019","Fiery Doll","Common"],
["OP03-020","Striker","Common"],
["OP03-021","Kuro","Leader"],
["OP03-022","Arlong","Leader"],
["OP03-023","Alvida","Common"],
["OP03-024","Gin","Rare"],
["OP03-025","Krieg","Super Rare"],
["OP03-026","Kuroobi","Uncommon"],
["OP03-027","Sham","Common"],
["OP03-028","Jango","Rare"],
["OP03-029","Chew","Uncommon"],
["OP03-030","Nami","Rare"],
["OP03-031","Pearl","Common"],
["OP03-032","Buggy","Common"],
["OP03-033","Hatchan","Uncommon"],
["OP03-034","Buchi","Uncommon"],
["OP03-035","Momoo","Common"],
["OP03-036","Out-of-the-Bag","Common"],
["OP03-037","Tooth Attack","Common"],
["OP03-038","Deathly Poison Gas Bomb MH5","Rare"],
["OP03-039","One, Two, Jango","Uncommon"],
["OP03-040","Nami","Leader"],
["OP03-041","Usopp","Super Rare"],
["OP03-042","Usopp's Pirate Crew","Common"],
["OP03-043","Gaimon","Common"],
["OP03-044","Kaya","Rare"],
["OP03-045","Carne","Uncommon"],
["OP03-046","Genzo","Common"],
["OP03-047","Zeff","Rare"],
["OP03-048","Nojiko","Uncommon"],
["OP03-049","Patty","Uncommon"],
["OP03-050","Boodle","Uncommon"],
["OP03-051","Bell-mère","Rare"],
["OP03-052","Merry","Common"],
["OP03-053","Yosaku & Johnny","Common"],
["OP03-054","Usopp's Rubber Band of Doom!!!","Common"],
["OP03-055","Gum-Gum Giant Gavel","Common"],
["OP03-056","Sanji's Pilaf","Uncommon"],
["OP03-057","Three Thousand Worlds","Rare"],
["OP03-058","Iceburg","Leader"],
["OP03-059","Kaku","Uncommon"],
["OP03-060","Kalifa","Uncommon"],
["OP03-061","Kiwi & Mozu","Common"],
["OP03-062","Kokoro","Rare"],
["OP03-063","Zambai","Uncommon"],
["OP03-064","Tilestone","Common"],
["OP03-065","Chimney & Gonbe","Common"],
["OP03-066","Paulie","Super Rare"],
["OP03-067","Peepley Lulu","Uncommon"],
["OP03-068","Minozebra","Common"],
["OP03-069","Minorhinoceros","Common"],
["OP03-070","Monkey.D.Luffy","Rare"],
["OP03-071","Rob Lucci","Rare"],
["OP03-072","Gum-Gum Jet Gatling","Rare"],
["OP03-073","Hull Dismantler Slash","Common"],
["OP03-074","Top Knot","Uncommon"],
["OP03-075","Galley-La Company","Common"],
["OP03-076","Rob Lucci","Leader"],
["OP03-077","Charlotte Linlin","Leader"],
["OP03-078","Issho","Super Rare"],
["OP03-079","Vergo","Uncommon"],
["OP03-080","Kaku","Super Rare"],
["OP03-081","Kalifa","Rare"],
["OP03-082","Kumadori","Common"],
["OP03-083","Corgy","Common"],
["OP03-084","Jerry","Common"],
["OP03-085","Jabra","Common"],
["OP03-086","Spandam","Rare"],
["OP03-087","Nero","Common"],
["OP03-088","Fukurou","Uncommon"],
["OP03-089","Brannew","Rare"],
["OP03-090","Blueno","Rare"],
["OP03-091","Helmeppo","Common"],
["OP03-092","Rob Lucci","Super Rare"],
["OP03-093","Wanze","Uncommon"],
["OP03-094","Air Door","Uncommon"],
["OP03-095","Soap Sheep","Common"],
["OP03-096","Tempest Kick Sky Slicer","Uncommon"],
["OP03-097","Six King Pistol","Rare"],
["OP03-098","Enies Lobby","Common"],
["OP03-099","Charlotte Katakuri","Leader"],
["OP03-100","Kingbaum","Common"],
["OP03-101","Camie","Common"],
["OP03-102","Sanji","Rare"],
["OP03-103","Bobbin the Disposer","Common"],
["OP03-104","Shirley","Uncommon"],
["OP03-105","Charlotte Oven","Uncommon"],
["OP03-106","Charlotte Opera","Common"],
["OP03-107","Charlotte Galette","Common"],
["OP03-108","Charlotte Cracker","Super Rare"],
["OP03-109","Charlotte Chiffon","Common"],
["OP03-110","Charlotte Smoothie","Rare"],
["OP03-111","Charlotte Praline","Common"],
["OP03-112","Charlotte Pudding","Rare"],
["OP03-113","Charlotte Perospero","Super Rare"],
["OP03-114","Charlotte Linlin","Super Rare"],
["OP03-115","Streusen","Rare"],
["OP03-116","Shirahoshi","Uncommon"],
["OP03-117","Napoleon","Uncommon"],
["OP03-118","Ikoku Sovereignty","Uncommon"],
["OP03-119","Buzz Cut Mochi","Rare"],
["OP03-120","Tropical Torment","Common"],
["OP03-121","Thunder Bolt","Common"],
["OP03-122","Sogeking","Secret Rare"],
["OP03-123","Charlotte Katakuri","Secret Rare"],
["OP03-013_p1","Marco",""],
["OP03-018_p1","Fire Fist",""],
["OP03-024_p1","Gin",""],
["OP03-025_p1","Krieg",""],
["OP03-041_p1","Usopp",""],
["OP03-047_p1","Zeff",""],
["OP03-066_p1","Paulie",""],
["OP03-078_p1","Issho",""],
["OP03-080_p1","Kaku",""],
["OP03-081_p1","Kalifa",""],
["OP03-086_p1","Spandam",""],
["OP03-092_p1","Rob Lucci",""],
["OP03-108_p1","Charlotte Cracker",""],
["OP03-112_p1","Charlotte Pudding",""],
["OP03-113_p1","Charlotte Perospero",""],
["OP03-114_p1","Charlotte Linlin",""],
["OP03-122_p1","Sogeking",""],
["OP03-123_p1","Charlotte Katakuri",""],
["OP03-001_p1","Portgas.D.Ace",""],
["OP03-021_p1","Kuro",""],
["OP03-022_p1","Arlong",""],
["OP03-040_p1","Nami",""],
["OP03-058_p1","Iceburg",""],
["OP03-076_p1","Rob Lucci",""],
["OP03-077_p1","Charlotte Linlin",""],
["OP03-099_p1","Charlotte Katakuri",""],
["OP03-122_p2","Sogeking",""],
["OP01-051_p2","Eustass\"Captain\"Kid","Special Card"],
["ST01-012_p1","Monkey.D.Luffy","Special Card"],
["ST03-009_p1","Donquixote Doflamingo","Special Card"],
["ST04-003_p1","Kaido","Special Card"],
["OP04-001","Nefeltari Vivi","Leader"],
["OP04-002","Igaram","Rare"],
["OP04-003","Usopp","Uncommon"],
["OP04-004","Karoo","Common"],
["OP04-005","Kung Fu Jugon","Common"],
["OP04-006","Koza","Uncommon"],
["OP04-007","Sanji","Common"],
["OP04-008","Chaka","Rare"],
["OP04-009","Super Spot-Billed Duck Troops","Uncommon"],
["OP04-010","Tony Tony.Chopper","Common"],
["OP04-011","Nami","Common"],
["OP04-012","Nefeltari Cobra","Common"],
["OP04-013","Pell","Super Rare"],
["OP04-014","Monkey.D.Luffy","Uncommon"],
["OP04-015","Roronoa Zoro","Rare"],
["OP04-016","Bad Manners Kick Course","Rare"],
["OP04-017","Happiness Punch","Common"],
["OP04-018","Enchanting Vertigo Dance","Uncommon"],
["OP04-019","Donquixote Doflamingo","Leader"],
["OP04-020","Issho","Leader"],
["OP04-021","Viola","Common"],
["OP04-022","Eric","Uncommon"],
["OP04-023","Kuro","Common"],
["OP04-024","Sugar","Super Rare"],
["OP04-025","Giolla","Common"],
["OP04-026","Senor Pink","Rare"],
["OP04-027","Daddy Masterson","Common"],
["OP04-028","Diamante","Rare"],
["OP04-029","Dellinger","Common"],
["OP04-030","Trebol","Rare"],
["OP04-031","Donquixote Doflamingo","Super Rare"],
["OP04-032","Baby 5","Uncommon"],
["OP04-033","Machvise","Uncommon"],
["OP04-034","Lao.G","Uncommon"],
["OP04-035","Spiderweb","Rare"],
["OP04-036","Donquixote Family","Common"],
["OP04-037","Flapping Thread","Uncommon"],
["OP04-038","The Weak Do Not Have the Right to Choose How They Die!!!","Common"],
["OP04-039","Rebecca","Leader"],
["OP04-040","Queen","Leader"],
["OP04-041","Apis","Common"],
["OP04-042","Ipponmatsu","Common"],
["OP04-043","Ulti","Rare"],
["OP04-044","Kaido","Super Rare"],
["OP04-045","King","Rare"],
["OP04-046","Queen","Uncommon"],
["OP04-047","Ice Oni","Common"],
["OP04-048","Sasaki","Uncommon"],
["OP04-049","Jack","Uncommon"],
["OP04-050","Hanger","Common"],
["OP04-051","Who's.Who","Rare"],
["OP04-052","Black Maria","Common"],
["OP04-053","Page One","Uncommon"],
["OP04-054","Rokki","Common"],
["OP04-055","Plague Rounds","Common"],
["OP04-056","Gum-Gum Red Roc","Rare"],
["OP04-057","Dragon Twister Demolition Breath","Uncommon"],
["OP04-058","Crocodile","Leader"],
["OP04-059","Iceburg","Uncommon"],
["OP04-060","Crocodile","Super Rare"],
["OP04-061","Tom","Common"],
["OP04-062","Bananagator","Common"],
["OP04-063","Franky","Rare"],
["OP04-064","Ms. All Sunday","Super Rare"],
["OP04-065","Miss.Goldenweek(Marianne)","Common"],
["OP04-066","Miss.Valentine(Mikita)","Rare"],
["OP04-067","Miss.MerryChristmas(Drophy)","Common"],
["OP04-068","Yokozuna","Common"],
["OP04-069","Mr.2.Bon.Kurei(Bentham)","Uncommon"],
["OP04-070","Mr.3(Galdino)","Uncommon"],
["OP04-071","Mr.4(Babe)","Uncommon"],
["OP04-072","Mr.5(Gem)","Rare"],
["OP04-073","Mr.13 & Ms.Friday","Common"],
["OP04-074","Colors Trap","Rare"],
["OP04-075","Nez-Palm Cannon","Uncommon"],
["OP04-076","Weakness...Is an Unforgivable Sin.","Common"],
["OP04-077","Ideo","Common"],
["OP04-078","Oimo & Kashii","Common"],
["OP04-079","Orlumbus","Common"],
["OP04-080","Gyats","Uncommon"],
["OP04-081","Cavendish","Rare"],
["OP04-082","Kyros","Rare"],
["OP04-083","Sabo","Super Rare"],
["OP04-084","Stussy","Common"],
["OP04-085","Suleiman","Uncommon"],
["OP04-086","Chinjao","Common"],
["OP04-087","Trafalgar Law","Common"],
["OP04-088","Hajrudin","Uncommon"],
["OP04-089","Bartolomeo","Rare"],
["OP04-090","Monkey.D.Luffy","Super Rare"],
["OP04-091","Leo","Uncommon"],
["OP04-092","Rebecca","Rare"],
["OP04-093","Gum-Gum King Kong Gun","Uncommon"],
["OP04-094","Trueno Bastardo","Rare"],
["OP04-095","Barrier!!","Common"],
["OP04-096","Corrida Coliseum","Common"],
["OP04-097","Otama","Common"],
["OP04-098","Toko","Uncommon"],
["OP04-099","Olin","Rare"],
["OP04-100","Capone\"Gang\"Bege","Rare"],
["OP04-101","Carmel","Common"],
["OP04-102","Kin'emon","Rare"],
["OP04-103","Kouzuki Hiyori","Uncommon"],
["OP04-104","Sanji","Super Rare"],
["OP04-105","Charlotte Amande","Rare"],
["OP04-106","Charlotte Bavarois","Common"],
["OP04-107","Charlotte Perospero","Common"],
["OP04-108","Charlotte Moscato","Uncommon"],
["OP04-109","Tonoyasu","Common"],
["OP04-110","Pound","Common"],
["OP04-111","Hera","Uncommon"],
["OP04-112","Yamato","Super Rare"],
["OP04-113","Rabiyan","Common"],
["OP04-114","Randolph","Common"],
["OP04-115","Gun Modoki","Common"],
["OP04-116","Diable Jambe Joue Shot","Uncommon"],
["OP04-117","Heavenly Fire","Rare"],
["OP04-118","Nefeltari Vivi","Secret Rare"],
["OP04-119","Donquixote Rosinante","Secret Rare"],
["OP04-013_p1","Pell",""],
["OP04-024_p1","Sugar",""],
["OP04-028_p1","Diamante",""],
["OP04-030_p1","Trebol",""],
["OP04-031_p1","Donquixote Doflamingo",""],
["OP04-044_p1","Kaido",""],
["OP04-051_p1","Who's.Who",""],
["OP04-060_p1","Crocodile",""],
["OP04-064_p1","Ms. All Sunday",""],
["OP04-072_p1","Mr.5(Gem)",""],
["OP04-082_p1","Kyros",""],
["OP04-083_p1","Sabo",""],
["OP04-090_p1","Monkey.D.Luffy",""],
["OP04-100_p1","Capone\"Gang\"Bege",""],
["OP04-104_p1","Sanji",""],
["OP04-112_p1","Yamato",""],
["OP04-118_p1","Nefeltari Vivi",""],
["OP04-119_p1","Donquixote Rosinante",""],
["OP04-001_p1","Nefeltari Vivi",""],
["OP04-019_p1","Donquixote Doflamingo",""],
["OP04-020_p1","Issho",""],
["OP04-039_p1","Rebecca",""],
["OP04-040_p1","Queen",""],
["OP04-058_p1","Crocodile",""],
["OP04-083_p2","Sabo",""],
["OP01-047_p2","Trafalgar Law","Special Card"],
["OP01-078_p2","Boa Hancock","Special Card"],
["OP02-004_p2","Edward.Newgate","Special Card"],
["OP02-085_p2","Magellan","Special Card"],
["OP02-099_p3","Sakazuki","Special Card"],
["OP05-001","Sabo","Leader"],
["OP05-002","Belo Betty","Leader"],
["OP05-003","Inazuma","Uncommon"],
["OP05-004","Emporio.Ivankov","Uncommon"],
["OP05-005","Karasu","Rare"],
["OP05-006","Koala","Super Rare"],
["OP05-007","Sabo","Super Rare"],
["OP05-008","Chaka","Uncommon"],
["OP05-009","Toh-Toh","Common"],
["OP05-010","Nico Robin","Uncommon"],
["OP05-011","Bartholomew Kuma","Common"],
["OP05-012","Hack","Common"],
["OP05-013","Bunny Joe","Common"],
["OP05-014","Pell","Common"],
["OP05-015","Belo Betty","Rare"],
["OP05-016","Morley","Rare"],
["OP05-017","Lindbergh","Rare"],
["OP05-018","Emporio Energy Hormone","Common"],
["OP05-019","Fire Fist","Rare"],
["OP05-020","Four Thousand-Brick Fist","Uncommon"],
["OP05-021","Revolutionary Army HQ","Uncommon"],
["OP05-022","Donquixote Rosinante","Leader"],
["OP05-023","Vergo","Rare"],
["OP05-024","Kuween","Common"],
["OP05-025","Gladius","Common"],
["OP05-026","Sarquiss","Common"],
["OP05-027","Trafalgar Law","Uncommon"],
["OP05-028","Donquixote Doflamingo","Common"],
["OP05-029","Donquixote Doflamingo","Uncommon"],
["OP05-030","Donquixote Rosinante","Rare"],
["OP05-031","Buffalo","Common"],
["OP05-032","Pica","Super Rare"],
["OP05-033","Baby 5","Common"],
["OP05-034","Baby 5","Rare"],
["OP05-035","Bellamy","Common"],
["OP05-036","Monet","Uncommon"],
["OP05-037","Because the Side of Justice Will Be Whichever Side Wins!!","Rare"],
["OP05-038","Charlestone","Common"],
["OP05-039","Stick-Stickem Meteora","Uncommon"],
["OP05-040","Birdcage","Common"],
["OP05-041","Sakazuki","Leader"],
["OP05-042","Issho","Rare"],
["OP05-043","Ulti","Super Rare"],
["OP05-044","John Giant","Common"],
["OP05-045","Stainless","Common"],
["OP05-046","Dalmatian","Common"],
["OP05-047","Basil Hawkins","Common"],
["OP05-048","Bastille","Uncommon"],
["OP05-049","Haccha","Uncommon"],
["OP05-050","Hina","Rare"],
["OP05-051","Borsalino","Super Rare"],
["OP05-052","Maynard","Common"],
["OP05-053","Mozambia","Common"],
["OP05-054","Monkey.D.Garp","Uncommon"],
["OP05-055","X.Drake","Rare"],
["OP05-056","X.Barrels","Common"],
["OP05-057","Hound Blaze","Rare"],
["OP05-058","It's a Waste of Human Life!!","Common"],
["OP05-059","Let Us Begin the World of Violence!!!","Uncommon"],
["OP05-060","Monkey.D.Luffy","Leader"],
["OP05-061","Uso-Hachi","Uncommon"],
["OP05-062","O-Nami","Uncommon"],
["OP05-063","O-Robi","Common"],
["OP05-064","Killer","Rare"],
["OP05-065","San-Gorou","Common"],
["OP05-066","Jinbe","Common"],
["OP05-067","Zoro-Juurou","Rare"],
["OP05-068","Chopa-Emon","Common"],
["OP05-069","Trafalgar Law","Super Rare"],
["OP05-070","Fra-Nosuke","Uncommon"],
["OP05-071","Bepo","Rare"],
["OP05-072","Hone-Kichi","Common"],
["OP05-073","Miss Doublefinger(Zala)","Uncommon"],
["OP05-074","Eustass\"Captain\"Kid","Super Rare"],
["OP05-075","Mr.1(Daz.Bonez)","Common"],
["OP05-076","When You're at Sea You Fight against Pirates!!","Rare"],
["OP05-077","Gamma Knife","Common"],
["OP05-078","Punk Rotten","Uncommon"],
["OP05-079","Viola","Uncommon"],
["OP05-080","Elizabello II","Uncommon"],
["OP05-081","One-Legged Toy Soldier","Uncommon"],
["OP05-082","Shirahoshi","Rare"],
["OP05-083","Sterry","Common"],
["OP05-084","Saint Charlos","Common"],
["OP05-085","Nefeltari Cobra","Uncommon"],
["OP05-086","Nefeltari Vivi","Rare"],
["OP05-087","Hakuba","Common"],
["OP05-088","Mansherry","Rare"],
["OP05-089","Saint Mjosgard","Common"],
["OP05-090","Riku Doldo III","Common"],
["OP05-091","Rebecca","Super Rare"],
["OP05-092","Saint Rosward","Common"],
["OP05-093","Rob Lucci","Super Rare"],
["OP05-094","Haute Couture Patch★Work","Rare"],
["OP05-095","Dragon Claw","Common"],
["OP05-096","I Bid 500 Million!!","Uncommon"],
["OP05-097","Mary Geoise","Common"],
["OP05-098","Enel","Leader"],
["OP05-099","Amazon","Uncommon"],
["OP05-100","Enel","Super Rare"],
["OP05-101","Ohm","Rare"],
["OP05-102","Gedatsu","Rare"],
["OP05-103","Kotori","Uncommon"],
["OP05-104","Conis","Uncommon"],
["OP05-105","Satori","Rare"],
["OP05-106","Shura","Rare"],
["OP05-107","Lieutenant Spacey","Common"],
["OP05-108","Nola","Common"],
["OP05-109","Pagaya","Common"],
["OP05-110","Holly","Common"],
["OP05-111","Hotori","Uncommon"],
["OP05-112","Captain McKinley","Common"],
["OP05-113","Yama","Common"],
["OP05-114","El Thor","Uncommon"],
["OP05-115","Two-Hundred Million Volts Amaru","Rare"],
["OP05-116","Hino Bird Zap","Common"],
["OP05-117","Upper Yard","Uncommon"],
["OP05-118","Kaido","Secret Rare"],
["OP05-119","Monkey.D.Luffy","Secret Rare"],
["OP05-006_p1","Koala",""],
["OP05-007_p1","Sabo",""],
["OP05-015_p1","Belo Betty",""],
["OP05-032_p1","Pica",""],
["OP05-034_p1","Baby 5",""],
["OP05-043_p1","Ulti",""],
["OP05-051_p1","Borsalino",""],
["OP05-055_p1","X.Drake",""],
["OP05-067_p1","Zoro-Juurou",""],
["OP05-069_p1","Trafalgar Law",""],
["OP05-074_p1","Eustass\"Captain\"Kid",""],
["OP05-088_p1","Mansherry",""],
["OP05-091_p1","Rebecca",""],
["OP05-093_p1","Rob Lucci",""],
["OP05-100_p1","Enel",""],
["OP05-102_p1","Gedatsu",""],
["OP05-118_p1","Kaido",""],
["OP05-119_p1","Monkey.D.Luffy",""],
["OP05-001_p1","Sabo",""],
["OP05-002_p1","Belo Betty",""],
["OP05-022_p1","Donquixote Rosinante",""],
["OP05-041_p1","Sakazuki",""],
["OP05-060_p1","Monkey.D.Luffy",""],
["OP05-098_p1","Enel",""],
["OP05-069_p2","Trafalgar Law",""],
["OP05-074_p2","Eustass\"Captain\"Kid",""],
["OP05-119_p2","Monkey.D.Luffy",""],
["OP01-016_p4","Nami","Special Card"],
["OP01-121_p2","Yamato","Special Card"],
["OP02-120_p2","Uta","Special Card"],
["OP03-092_p2","Rob Lucci","Special Card"],
["OP04-044_p2","Kaido","Special Card"],
["OP05-100_p2","Enel","Special Card"],
["ST01-012_p2","Monkey.D.Luffy","Special Card"],
["ST01-012_p3","Monkey.D.Luffy","Special Card"],
["OP06-001","Uta","Leader"],
["OP06-002","Inazuma","Common"],
["OP06-003","Emporio.Ivankov","Uncommon"],
["OP06-004","Baron Omatsuri","Common"],
["OP06-005","Gasparde","Common"],
["OP06-006","Saga","Uncommon"],
["OP06-007","Shanks","Super Rare"],
["OP06-008","Schneider","Common"],
["OP06-009","Shuraiya","Super Rare"],
["OP06-010","Douglas Bullet","Rare"],
["OP06-011","Tot Musica","Rare"],
["OP06-012","Bear.King","Uncommon"],
["OP06-013","Monkey.D.Luffy","Rare"],
["OP06-014","Ratchet","Common"],
["OP06-015","Lily Carnation","Common"],
["OP06-016","Raise Max","Uncommon"],
["OP06-017","Meteor-Strike of Love","Common"],
["OP06-018","Gum-Gum King Kong Gatling","Rare"],
["OP06-019","Blue Dragon Seal Water Stream","Uncommon"],
["OP06-020","Hody Jones","Leader"],
["OP06-021","Perona","Leader"],
["OP06-022","Yamato","Leader"],
["OP06-023","Arlong","Rare"],
["OP06-024","Ikaros Much","Uncommon"],
["OP06-025","Camie","Rare"],
["OP06-026","Koushirou","Common"],
["OP06-027","Gyro","Common"],
["OP06-028","Zeo","Common"],
["OP06-029","Daruma","Uncommon"],
["OP06-030","Dosun","Common"],
["OP06-031","Hatchan","Uncommon"],
["OP06-032","Hammond","Common"],
["OP06-033","Vander Decken IX","Rare"],
["OP06-034","Hyouzou","Uncommon"],
["OP06-035","Hody Jones","Super Rare"],
["OP06-036","Ryuma","Rare"],
["OP06-037","Wadatsumi","Common"],
["OP06-038","The Billion-fold World Trichiliocosm","Uncommon"],
["OP06-039","You Ain't Even Worth Killing Time!!","Rare"],
["OP06-040","Shark Arrows","Common"],
["OP06-041","The Ark Noah","Common"],
["OP06-042","Vinsmoke Reiju","Leader"],
["OP06-043","Aramaki","Super Rare"],
["OP06-044","Gion","Uncommon"],
["OP06-045","Kuzan","Uncommon"],
["OP06-046","Sakazuki","Uncommon"],
["OP06-047","Charlotte Pudding","Rare"],
["OP06-048","Zeff","Common"],
["OP06-049","Sengoku","Common"],
["OP06-050","Tashigi","Rare"],
["OP06-051","Tsuru","Rare"],
["OP06-052","Tokikake","Common"],
["OP06-053","Jaguar.D.Saul","Common"],
["OP06-054","Borsalino","Uncommon"],
["OP06-055","Monkey.D.Garp","Common"],
["OP06-056","Ama no Murakumo Sword","Uncommon"],
["OP06-057","But I Will Never Doubt a Woman's Tears!!!!","Common"],
["OP06-058","Gravity Blade Raging Tiger","Rare"],
["OP06-059","White Snake","Uncommon"],
["OP06-060","Vinsmoke Ichiji","Common"],
["OP06-061","Vinsmoke Ichiji","Rare"],
["OP06-062","Vinsmoke Judge","Super Rare"],
["OP06-063","Vinsmoke Sora","Uncommon"],
["OP06-064","Vinsmoke Niji","Common"],
["OP06-065","Vinsmoke Niji","Rare"],
["OP06-066","Vinsmoke Yonji","Common"],
["OP06-067","Vinsmoke Yonji","Rare"],
["OP06-068","Vinsmoke Reiju","Common"],
["OP06-069","Vinsmoke Reiju","Super Rare"],
["OP06-070","Eldoraggo","Common"],
["OP06-071","Gild Tesoro","Uncommon"],
["OP06-072","Cosette","Common"],
["OP06-073","Shiki","Uncommon"],
["OP06-074","Zephyr (Navy)","Rare"],
["OP06-075","Count Battler","Common"],
["OP06-076","Hitokiri Kamazo","Uncommon"],
["OP06-077","Black Bug","Rare"],
["OP06-078","GERMA 66","Uncommon"],
["OP06-079","Kingdom of GERMA","Common"],
["OP06-080","Gecko Moria","Leader"],
["OP06-081","Absalom","Rare"],
["OP06-082","Inuppe","Common"],
["OP06-083","Oars","Uncommon"],
["OP06-084","Jigoro of the Wind","Common"],
["OP06-085","Kumacy","Uncommon"],
["OP06-086","Gecko Moria","Super Rare"],
["OP06-087","Cerberus","Common"],
["OP06-088","Sai","Uncommon"],
["OP06-089","Taralan","Common"],
["OP06-090","Dr. Hogback","Rare"],
["OP06-091","Victoria Cindry","Uncommon"],
["OP06-092","Brook","Rare"],
["OP06-093","Perona","Super Rare"],
["OP06-094","Lola","Common"],
["OP06-095","Shadows Asgard","Uncommon"],
["OP06-096","...Nothing...at All!!!","Common"],
["OP06-097","Negative Hollow","Rare"],
["OP06-098","Thriller Bark","Common"],
["OP06-099","Aisa","Common"],
["OP06-100","Inuarashi","Uncommon"],
["OP06-101","O-Nami","Rare"],
["OP06-102","Kamakiri","Common"],
["OP06-103","Kawamatsu","Common"],
["OP06-104","Kikunojo","Rare"],
["OP06-105","Genbo","Common"],
["OP06-106","Kouzuki Hiyori","Super Rare"],
["OP06-107","Kouzuki Momonosuke","Super Rare"],
["OP06-108","Tenguyama Hitetsu","Common"],
["OP06-109","Denjiro","Uncommon"],
["OP06-110","Nekomamushi","Uncommon"],
["OP06-111","Braham","Common"],
["OP06-112","Raizo","Common"],
["OP06-113","Raki","Common"],
["OP06-114","Wyper","Uncommon"],
["OP06-115","You're the One Who Should Disappear.","Rare"],
["OP06-116","Reject","Rare"],
["OP06-117","The Ark Maxim","Common"],
["OP06-118","Roronoa Zoro","Secret Rare"],
["OP06-119","Sanji","Secret Rare"],
["OP06-007_p1","Shanks",""],
["OP06-009_p1","Shuraiya",""],
["OP06-013_p1","Monkey.D.Luffy",""],
["OP06-025_p1","Camie",""],
["OP06-035_p1","Hody Jones",""],
["OP06-043_p1","Aramaki",""],
["OP06-050_p1","Tashigi",""],
["OP06-061_p1","Vinsmoke Ichiji",""],
["OP06-062_p1","Vinsmoke Judge",""],
["OP06-069_p1","Vinsmoke Reiju",""],
["OP06-081_p1","Absalom",""],
["OP06-086_p1","Gecko Moria",""],
["OP06-093_p1","Perona",""],
["OP06-101_p1","O-Nami",""],
["OP06-106_p1","Kouzuki Hiyori",""],
["OP06-107_p1","Kouzuki Momonosuke",""],
["OP06-118_p1","Roronoa Zoro",""],
["OP06-119_p1","Sanji",""],
["OP06-001_p1","Uta",""],
["OP06-020_p1","Hody Jones",""],
["OP06-021_p1","Perona",""],
["OP06-022_p1","Yamato",""],
["OP06-042_p1","Vinsmoke Reiju",""],
["OP06-080_p1","Gecko Moria",""],
["OP06-118_p2","Roronoa Zoro",""],
["OP03-008_p1","Buggy","Special Card"],
["OP03-114_p2","Charlotte Linlin","Special Card"],
["OP04-024_p2","Sugar","Special Card"],
["OP04-064_p2","Ms. All Sunday","Special Card"],
["OP05-051_p2","Borsalino","Special Card"],
["OP05-091_p2","Rebecca","Special Card"],
["ST01-007_p5","Nami","Treasure Rare"],
["OP07-001","Monkey.D.Dragon","Leader"],
["OP07-002","Ain","Rare"],
["OP07-003","Outlook III","Rare"],
["OP07-004","Curly.Dadan","Rare"],
["OP07-005","Carina","Rare"],
["OP07-006","Sterry","Common"],
["OP07-007","Dice","Common"],
["OP07-008","Mr. Tanaka","Uncommon"],
["OP07-009","Dogura & Magura","Common"],
["OP07-010","Baccarat","Rare"],
["OP07-011","Bluejam","Common"],
["OP07-012","Porchemy","Common"],
["OP07-013","Masked Deuce","Uncommon"],
["OP07-014","Moda","Uncommon"],
["OP07-015","Monkey.D.Dragon","Super Rare"],
["OP07-016","Galaxy Wink","Rare"],
["OP07-017","Dragon Breath","Uncommon"],
["OP07-018","KEEP OUT","Common"],
["OP07-019","Jewelry Bonney","Leader"],
["OP07-020","Aladine","Common"],
["OP07-021","Urouge","Rare"],
["OP07-022","Otama","Rare"],
["OP07-023","Caribou","Uncommon"],
["OP07-024","Koala","Common"],
["OP07-025","Coribou","Common"],
["OP07-026","Jewelry Bonney","Super Rare"],
["OP07-027","Jinbe","Common"],
["OP07-028","Scratchmen Apoo","Common"],
["OP07-029","Basil Hawkins","Super Rare"],
["OP07-030","Pappag","Common"],
["OP07-031","Bartolomeo","Uncommon"],
["OP07-032","Fisher Tiger","Rare"],
["OP07-033","Monkey.D.Luffy","Uncommon"],
["OP07-034","Roronoa Zoro","Uncommon"],
["OP07-035","Karmic Punishment","Common"],
["OP07-036","Demonic Aura Nine-Sword Style Asura Demon Nine Flash","Rare"],
["OP07-037","More Pizza!!","Uncommon"],
["OP07-038","Boa Hancock","Leader"],
["OP07-039","Edward Weevil","Common"],
["OP07-040","Crocodile","Uncommon"],
["OP07-041","Gloriosa (Grandma Nyon)","Uncommon"],
["OP07-042","Gecko Moria","Common"],
["OP07-043","Salome","Uncommon"],
["OP07-044","Dracule Mihawk","Common"],
["OP07-045","Jinbe","Super Rare"],
["OP07-046","Sengoku","Rare"],
["OP07-047","Trafalgar Law","Rare"],
["OP07-048","Donquixote Doflamingo","Uncommon"],
["OP07-049","Buckin","Common"],
["OP07-050","Boa Sandersonia","Common"],
["OP07-051","Boa Hancock","Super Rare"],
["OP07-052","Boa Marigold","Common"],
["OP07-053","Portgas.D.Ace","Rare"],
["OP07-054","Marguerite","Rare"],
["OP07-055","Snake Dance","Common"],
["OP07-056","Slave Arrow","Uncommon"],
["OP07-057","Perfume Femur","Rare"],
["OP07-058","Island of Women","Common"],
["OP07-059","Foxy","Leader"],
["OP07-060","Itomimizu","Uncommon"],
["OP07-061","Vinsmoke Sanji","Common"],
["OP07-062","Vinsmoke Reiju","Common"],
["OP07-063","Capote","Common"],
["OP07-064","Sanji","Super Rare"],
["OP07-065","Gina","Uncommon"],
["OP07-066","Tony Tony.Chopper","Rare"],
["OP07-067","Tonjit","Common"],
["OP07-068","Hamburg","Uncommon"],
["OP07-069","Pickles","Common"],
["OP07-070","Big Bun","Uncommon"],
["OP07-071","Foxy","Rare"],
["OP07-072","Porche","Super Rare"],
["OP07-073","Monkey.D.Luffy","Rare"],
["OP07-074","Monda","Common"],
["OP07-075","Slow-Slow Beam","Uncommon"],
["OP07-076","Slow-Slow Beam Sword","Common"],
["OP07-077","We're Going to Claim the One Piece!!!","Rare"],
["OP07-078","Megaton Nine-Tails Rush","Common"],
["OP07-079","Rob Lucci","Leader"],
["OP07-080","Kaku","Rare"],
["OP07-081","Kalifa","Common"],
["OP07-082","Captain John","Uncommon"],
["OP07-083","Gecko Moria","Uncommon"],
["OP07-084","Gismonda","Common"],
["OP07-085","Stussy","Super Rare"],
["OP07-086","Spandam","Common"],
["OP07-087","Baskerville","Common"],
["OP07-088","Hattori","Uncommon"],
["OP07-089","Maha","Common"],
["OP07-090","Morgans","Common"],
["OP07-091","Monkey.D.Luffy","Rare"],
["OP07-092","Joseph","Uncommon"],
["OP07-093","Rob Lucci","Rare"],
["OP07-094","Shave","Uncommon"],
["OP07-095","Iron Body","Common"],
["OP07-096","Tempest Kick","Rare"],
["OP07-097","Vegapunk","Leader"],
["OP07-098","Atlas","Uncommon"],
["OP07-099","Usopp","Common"],
["OP07-100","Edison","Common"],
["OP07-101","Shaka","Uncommon"],
["OP07-102","Jinbe","Common"],
["OP07-103","Tony Tony.Chopper","Common"],
["OP07-104","Nico Robin","Uncommon"],
["OP07-105","Pythagoras","Uncommon"],
["OP07-106","Fuza","Common"],
["OP07-107","Franky","Rare"],
["OP07-108","Vega Force 01","Common"],
["OP07-109","Monkey.D.Luffy","Super Rare"],
["OP07-110","York","Common"],
["OP07-111","Lilith","Super Rare"],
["OP07-112","Lucy","Rare"],
["OP07-113","Roronoa Zoro","Uncommon"],
["OP07-114","He Possesses the World's Most Brilliant Mind","Uncommon"],
["OP07-115","I Re-Quasar Helllp!!","Common"],
["OP07-116","Blaze Slice","Rare"],
["OP07-117","Egghead","Common"],
["OP07-118","Sabo","Secret Rare"],
["OP07-119","Portgas.D.Ace","Secret Rare"],
["OP07-005_p1","Carina",""],
["OP07-015_p1","Monkey.D.Dragon",""],
["OP07-022_p1","Otama",""],
["OP07-026_p1","Jewelry Bonney",""],
["OP07-029_p1","Basil Hawkins",""],
["OP07-045_p1","Jinbe",""],
["OP07-046_p1","Sengoku",""],
["OP07-047_p1","Trafalgar Law",""],
["OP07-051_p1","Boa Hancock",""],
["OP07-064_p1","Sanji",""],
["OP07-071_p1","Foxy",""],
["OP07-072_p1","Porche",""],
["OP07-085_p1","Stussy",""],
["OP07-107_p1","Franky",""],
["OP07-109_p1","Monkey.D.Luffy",""],
["OP07-111_p1","Lilith",""],
["OP07-118_p1","Sabo",""],
["OP07-119_p1","Portgas.D.Ace",""],
["OP07-001_p1","Monkey.D.Dragon",""],
["OP07-019_p1","Jewelry Bonney",""],
["OP07-038_p1","Boa Hancock",""],
["OP07-059_p1","Foxy",""],
["OP07-079_p1","Rob Lucci",""],
["OP07-097_p1","Vegapunk",""],
["OP07-051_p2","Boa Hancock",""],
["OP01-035_p4","Okiku","Special Card"],
["OP01-073_p2","Donquixote Doflamingo","Special Card"],
["OP03-003_p1","Izo","Special Card"],
["OP03-078_p2","Issho","Special Card"],
["OP05-074_p3","Eustass\"Captain\"Kid","Special Card"],
["OP06-101_p2","O-Nami","Special Card"],
["ST10-010_p2","Trafalgar Law","Treasure Rare"],
["OP08-001","Tony Tony.Chopper","Leader"],
["OP08-002","Marco","Leader"],
["OP08-003","Twenty Doctors","Common"],
["OP08-004","Kuromarimo","Common"],
["OP08-005","Chess","Common"],
["OP08-006","Chessmarimo","Uncommon"],
["OP08-007","Tony Tony.Chopper","Super Rare"],
["OP08-008","Dalton","Rare"],
["OP08-009","Maria Onion Bear","Common"],
["OP08-010","Hiking Bear","Uncommon"],
["OP08-011","Musshuru","Common"],
["OP08-012","Lapins","Uncommon"],
["OP08-013","Robson","Uncommon"],
["OP08-014","Wapol","Rare"],
["OP08-015","Dr.Kureha","Rare"],
["OP08-016","Dr.Hiriluk","Rare"],
["OP08-017","I'd Never Shoot You!!!!","Common"],
["OP08-018","Cloven Rose","Rare"],
["OP08-019","Munch-Munch Mutation","Uncommon"],
["OP08-020","Drum Kingdom","Common"],
["OP08-021","Carrot","Leader"],
["OP08-022","Inuarashi","Uncommon"],
["OP08-023","Carrot","Super Rare"],
["OP08-024","Concelot","Uncommon"],
["OP08-025","Shishilian","Common"],
["OP08-026","Giovanni","Common"],
["OP08-027","Tristan","Common"],
["OP08-028","Nekomamushi","Uncommon"],
["OP08-029","Pekoms","Common"],
["OP08-030","Pedro","Rare"],
["OP08-031","Miyagi","Common"],
["OP08-032","Milky","Uncommon"],
["OP08-033","Roddy","Common"],
["OP08-034","Wanda","Rare"],
["OP08-035","BB","Common"],
["OP08-036","Electrical Luna","Rare"],
["OP08-037","Garchu","Uncommon"],
["OP08-038","We Would Never Sell a Comrade to an Enemy!!!","Common"],
["OP08-039","Zou","Rare"],
["OP08-040","Atmos","Uncommon"],
["OP08-041","Aphelandra","Common"],
["OP08-042","Edward Weevil","Uncommon"],
["OP08-043","Edward.Newgate","Super Rare"],
["OP08-044","Kingdew","Uncommon"],
["OP08-045","Thatch","Uncommon"],
["OP08-046","Shakuyaku","Rare"],
["OP08-047","Jozu","Rare"],
["OP08-048","Sweetpea","Common"],
["OP08-049","Speed Jil","Common"],
["OP08-050","Namule","Common"],
["OP08-051","Buckin","Common"],
["OP08-052","Portgas.D.Ace","Rare"],
["OP08-053","Thank You...for Loving Me!!","Rare"],
["OP08-054","You Can't Take Our King This Early in the Game.","Common"],
["OP08-055","Phoenix Brand","Uncommon"],
["OP08-056","Moby Dick","Common"],
["OP08-057","King","Leader"],
["OP08-058","Charlotte Pudding","Leader"],
["OP08-059","Alber","Uncommon"],
["OP08-060","King","Rare"],
["OP08-061","Charlotte Oven","Uncommon"],
["OP08-062","Charlotte Katakuri","Uncommon"],
["OP08-063","Charlotte Katakuri","Rare"],
["OP08-064","Charlotte Cracker","Common"],
["OP08-065","Charlotte Smoothie","Common"],
["OP08-066","Charlotte Brulee","Uncommon"],
["OP08-067","Charlotte Pudding","Rare"],
["OP08-068","Charlotte Perospero","Common"],
["OP08-069","Charlotte Linlin","Super Rare"],
["OP08-070","Baron Tamago","Common"],
["OP08-071","Count Niwatori","Common"],
["OP08-072","Biscuit Warrior","Common"],
["OP08-073","Viscount Hiyoko","Common"],
["OP08-074","Black Maria","Super Rare"],
["OP08-075","Candy Maiden","Common"],
["OP08-076","It's to Die For...","Uncommon"],
["OP08-077","Conquest of the Sea","Rare"],
["OP08-078","Ulti","Common"],
["OP08-079","Kaido","Super Rare"],
["OP08-080","Queen","Rare"],
["OP08-081","Guernica","Common"],
["OP08-082","Sasaki","Rare"],
["OP08-083","Sheepshead","Uncommon"],
["OP08-084","Jack","Super Rare"],
["OP08-085","Jinbe","Uncommon"],
["OP08-086","Ginrummy","Common"],
["OP08-087","Scratchmen Apoo","Uncommon"],
["OP08-088","Duval","Uncommon"],
["OP08-089","Basil Hawkins","Common"],
["OP08-090","Hamlet","Common"],
["OP08-091","Who's.Who","Rare"],
["OP08-092","Page One","Rare"],
["OP08-093","X.Drake","Common"],
["OP08-094","Imperial Flame","Rare"],
["OP08-095","Iron Body Fang Flash","Uncommon"],
["OP08-096","People's Dreams Don't Ever End!!","Common"],
["OP08-097","Heliceratops","Common"],
["OP08-098","Kalgara","Leader"],
["OP08-099","Kalgara","Common"],
["OP08-100","South Bird","Uncommon"],
["OP08-101","Charlotte Angel","Common"],
["OP08-102","Charlotte Opera","Uncommon"],
["OP08-103","Charlotte Custard","Uncommon"],
["OP08-104","Charlotte Poire","Common"],
["OP08-105","Jewelry Bonney","Super Rare"],
["OP08-106","Nami","Super Rare"],
["OP08-107","Nitro","Common"],
["OP08-108","Mont Blanc Cricket","Common"],
["OP08-109","Mont Blanc Noland","Rare"],
["OP08-110","Wyper","Rare"],
["OP08-111","S-Shark","Uncommon"],
["OP08-112","S-Snake","Super Rare"],
["OP08-113","S-Bear","Common"],
["OP08-114","S-Hawk","Rare"],
["OP08-115","The Earth Will Not Lose!","Rare"],
["OP08-116","Burn Bazooka","Common"],
["OP08-117","Burn Blade","Uncommon"],
["OP08-118","Silvers Rayleigh","Secret Rare"],
["OP08-119","Kaido & Linlin","Secret Rare"],
["OP08-007_p1","Tony Tony.Chopper",""],
["OP08-015_p1","Dr.Kureha",""],
["OP08-023_p1","Carrot",""],
["OP08-030_p1","Pedro",""],
["OP08-043_p1","Edward.Newgate",""],
["OP08-052_p1","Portgas.D.Ace",""],
["OP08-067_p1","Charlotte Pudding",""],
["OP08-069_p1","Charlotte Linlin",""],
["OP08-074_p1","Black Maria",""],
["OP08-079_p1","Kaido",""],
["OP08-080_p1","Queen",""],
["OP08-084_p1","Jack",""],
["OP08-105_p1","Jewelry Bonney",""],
["OP08-106_p1","Nami",""],
["OP08-110_p1","Wyper",""],
["OP08-112_p1","S-Snake",""],
["OP08-118_p1","Silvers Rayleigh",""],
["OP08-119_p1","Kaido & Linlin",""],
["OP08-001_p1","Tony Tony.Chopper",""],
["OP08-002_p1","Marco",""],
["OP08-021_p1","Carrot",""],
["OP08-057_p1","King",""],
["OP08-058_p1","Charlotte Pudding",""],
["OP08-098_p1","Kalgara",""],
["OP08-118_p2","Silvers Rayleigh",""],
["OP02-013_p3","Portgas.D.Ace","Special Card"],
["OP03-112_p2","Charlotte Pudding","Special Card"],
["ST02-007_p4","Jewelry Bonney","Special Card"],
["ST03-004_p2","Gecko Moria","Special Card"],
["ST04-005_p2","Queen","Special Card"],
["ST06-006_p4","Tashigi","Special Card"],
["OP07-109_p3","Monkey.D.Luffy","Treasure Rare"],
["OP09-001","Shanks","Leader"],
["OP09-002","Uta","Rare"],
["OP09-003","Shachi & Penguin","Common"],
["OP09-004","Shanks","Super Rare"],
["OP09-005","Silvers Rayleigh","Rare"],
["OP09-006","Howling Gab","Common"],
["OP09-007","Heat","Common"],
["OP09-008","Building Snake","Uncommon"],
["OP09-009","Benn.Beckman","Super Rare"],
["OP09-010","Bonk Punch","Common"],
["OP09-011","Hongo","Uncommon"],
["OP09-012","Monster","Common"],
["OP09-013","Yasopp","Rare"],
["OP09-014","Limejuice","Uncommon"],
["OP09-015","Lucky.Roux","Rare"],
["OP09-016","Rockstar","Common"],
["OP09-017","Wire","Uncommon"],
["OP09-018","Get Out of Here!","Uncommon"],
["OP09-019","Nobody Hurts a Friend of Mine!!!!","Common"],
["OP09-020","Come On!! We'll Fight You!!","Rare"],
["OP09-021","Red Force","Common"],
["OP09-022","Lim","Leader"],
["OP09-023","Adio","Super Rare"],
["OP09-024","Usopp","Common"],
["OP09-025","Crocodile","Uncommon"],
["OP09-026","Sakazuki","Rare"],
["OP09-027","Sabo","Uncommon"],
["OP09-028","Sanji","Common"],
["OP09-029","Tony Tony.Chopper","Common"],
["OP09-030","Trafalgar Law","Uncommon"],
["OP09-031","Donquixote Doflamingo","Rare"],
["OP09-032","Donquixote Rosinante","Uncommon"],
["OP09-033","Nico Robin","Common"],
["OP09-034","Perona","Rare"],
["OP09-035","Portgas.D.Ace","Uncommon"],
["OP09-036","Monkey.D.Luffy","Common"],
["OP09-037","Lim","Super Rare"],
["OP09-038","Rob Lucci","Common"],
["OP09-039","Gum-Gum Cuatro Jet Cross Shock Bazooka","Rare"],
["OP09-040","Thunder Lance Flip Caliber Phoenix Shot","Uncommon"],
["OP09-041","Soul Franky Swing Arm Boxing Solid","Common"],
["OP09-042","Buggy","Leader"],
["OP09-043","Alvida","Uncommon"],
["OP09-044","Izo","Uncommon"],
["OP09-045","Cabaji","Uncommon"],
["OP09-046","Crocodile","Super Rare"],
["OP09-047","Kouzuki Oden","Common"],
["OP09-048","Dracule Mihawk","Super Rare"],
["OP09-049","Jozu","Common"],
["OP09-050","Nami","Rare"],
["OP09-051","Buggy","Rare"],
["OP09-052","Marco","Common"],
["OP09-053","Mohji","Uncommon"],
["OP09-054","Richie","Common"],
["OP09-055","Mr.1(Daz.Bonez)","Common"],
["OP09-056","Mr.3(Galdino)","Rare"],
["OP09-057","Cross Guild","Rare"],
["OP09-058","Special Muggy Ball","Common"],
["OP09-059","Murder at the Steam Bath","Uncommon"],
["OP09-060","Emptee Bluffs Island","Common"],
["OP09-061","Monkey.D.Luffy","Leader"],
["OP09-062","Nico Robin","Leader"],
["OP09-063","Usopp","Common"],
["OP09-064","Killer","Uncommon"],
["OP09-065","Sanji","Super Rare"],
["OP09-066","Jean Bart","Uncommon"],
["OP09-067","Jinbe","Common"],
["OP09-068","Tony Tony.Chopper","Uncommon"],
["OP09-069","Trafalgar Law","Rare"],
["OP09-070","Nami","Uncommon"],
["OP09-071","Nico Robin","Common"],
["OP09-072","Franky","Super Rare"],
["OP09-073","Brook","Common"],
["OP09-074","Bepo","Common"],
["OP09-075","Eustass\"Captain\"Kid","Uncommon"],
["OP09-076","Roronoa Zoro","Rare"],
["OP09-077","Gum-Gum Lightning","Uncommon"],
["OP09-078","Gum-Gum Giant","Rare"],
["OP09-079","Gum-Gum Jump Rope","Common"],
["OP09-080","Thousand Sunny","Common"],
["OP09-081","Marshall.D.Teach","Leader"],
["OP09-082","Avalo Pizarro","Common"],
["OP09-083","Van Augur","Rare"],
["OP09-084","Catarina Devon","Uncommon"],
["OP09-085","Gecko Moria","Common"],
["OP09-086","Jesus Burgess","Rare"],
["OP09-087","Charlotte Pudding","Common"],
["OP09-088","Shiryu","Uncommon"],
["OP09-089","Stronger","Uncommon"],
["OP09-090","Doc Q","Rare"],
["OP09-091","Vasco Shot","Common"],
["OP09-092","Marshall.D.Teach","Common"],
["OP09-093","Marshall.D.Teach","Super Rare"],
["OP09-094","Peachbeard","Common"],
["OP09-095","Laffitte","Rare"],
["OP09-096","My Era...Begins!!","Rare"],
["OP09-097","Black Vortex","Common"],
["OP09-098","Black Hole","Uncommon"],
["OP09-099","Fullalead","Common"],
["OP09-100","Karasu","Uncommon"],
["OP09-101","Kuzan","Rare"],
["OP09-102","Professor Clover","Rare"],
["OP09-103","Koala","Super Rare"],
["OP09-104","Sabo","Rare"],
["OP09-105","Sanji","Common"],
["OP09-106","Nico Olvia","Common"],
["OP09-107","Nico Robin","Rare"],
["OP09-108","Bartholomew Kuma","Uncommon"],
["OP09-109","Jaguar.D.Saul","Uncommon"],
["OP09-110","Pierre","Common"],
["OP09-111","Brook","Common"],
["OP09-112","Belo Betty","Common"],
["OP09-113","Morley","Common"],
["OP09-114","Lindbergh","Common"],
["OP09-115","Ice Block Partisan","Uncommon"],
["OP09-116","Never Underestimate the Power of Miracles!!","Common"],
["OP09-117","Dereshi!","Rare"],
["OP09-118","Gol.D.Roger","Secret Rare"],
["OP09-119","Monkey.D.Luffy","Secret Rare"],
["OP09-002_p1","Uta",""],
["OP09-004_p1","Shanks",""],
["OP09-009_p1","Benn.Beckman",""],
["OP09-023_p1","Adio",""],
["OP09-034_p1","Perona",""],
["OP09-037_p1","Lim",""],
["OP09-046_p1","Crocodile",""],
["OP09-048_p1","Dracule Mihawk",""],
["OP09-050_p1","Nami",""],
["OP09-051_p1","Buggy",""],
["OP09-065_p1","Sanji",""],
["OP09-069_p1","Trafalgar Law",""],
["OP09-072_p1","Franky",""],
["OP09-093_p1","Marshall.D.Teach",""],
["OP09-103_p1","Koala",""],
["OP09-107_p1","Nico Robin",""],
["OP09-118_p1","Gol.D.Roger",""],
["OP09-119_p1","Monkey.D.Luffy",""],
["OP09-001_p1","Shanks",""],
["OP09-022_p1","Lim",""],
["OP09-042_p1","Buggy",""],
["OP09-061_p1","Monkey.D.Luffy",""],
["OP09-062_p1","Nico Robin",""],
["OP09-081_p1","Marshall.D.Teach",""],
["OP09-004_p2","Shanks",""],
["OP09-051_p2","Buggy",""],
["OP09-093_p2","Marshall.D.Teach",""],
["OP09-119_p2","Monkey.D.Luffy",""],
["OP09-118_p2","Gol.D.Roger",""],
["OP09-004_p3","Shanks","Special Card"],
["OP09-051_p3","Buggy","Special Card"],
["OP09-093_p3","Marshall.D.Teach","Special Card"],
["OP05-119_p3","Monkey.D.Luffy","Special Card"],
["OP04-119_p2","Donquixote Rosinante","Special Card"],
["OP05-067_p3","Zoro-Juurou","Special Card"],
["OP05-093_p2","Rob Lucci","Special Card"],
["OP07-015_p2","Monkey.D.Dragon","Special Card"],
["OP07-051_p3","Boa Hancock","Special Card"],
["OP08-106_p2","Nami","Special Card"],
["ST18-004_p1","Zoro-Juurou","Treasure Rare"],
["OP10-001","Smoker","Leader"],
["OP10-002","Caesar Clown","Leader"],
["OP10-003","Sugar","Leader"],
["OP10-004","Vergo","Rare"],
["OP10-005","Sanji","Super Rare"],
["OP10-006","Caesar Clown","Uncommon"],
["OP10-007","Ceaser Soldier","Uncommon"],
["OP10-008","Scotch","Common"],
["OP10-009","Smiley","Rare"],
["OP10-010","Chadros.Higelyges (Brownbeard)","Common"],
["OP10-011","Tony Tony.Chopper","Rare"],
["OP10-012","Dragon Number Thirteen","Common"],
["OP10-013","Nami","Common"],
["OP10-014","Franky","Common"],
["OP10-015","Mocha","Uncommon"],
["OP10-016","Monet","Super Rare"],
["OP10-017","Rock","Common"],
["OP10-018","Ten-Layer Igloo","Common"],
["OP10-019","Divine Departure","Rare"],
["OP10-020","Gum-Gum UFO","Uncommon"],
["OP10-021","Punk Hazard","Common"],
["OP10-022","Trafalgar Law","Leader"],
["OP10-023","Issho","Common"],
["OP10-024","Edward.Newgate","Common"],
["OP10-025","Enel","Rare"],
["OP10-026","Kin'emon","Common"],
["OP10-027","Kin'emon","Uncommon"],
["OP10-028","Kouzuki Momonosuke","Uncommon"],
["OP10-029","Dracule Mihawk","Rare"],
["OP10-030","Smoker","Super Rare"],
["OP10-031","Sengoku","Common"],
["OP10-032","Tashigi","Super Rare"],
["OP10-033","Nami","Uncommon"],
["OP10-034","Franky","Common"],
["OP10-035","Brook","Common"],
["OP10-036","Perona","Common"],
["OP10-037","Lim","Rare"],
["OP10-038","Roronoa Zoro","Common"],
["OP10-039","Gum-Gum Dragon Fire Pistol Twister Star","Uncommon"],
["OP10-040","The Weak Do Not Have the Right to Choose How They Die","Common"],
["OP10-041","Radio Knife","Rare"],
["OP10-042","Usopp","Leader"],
["OP10-043","Moocy","Common"],
["OP10-044","Cub","Uncommon"],
["OP10-045","Cavendish","Rare"],
["OP10-046","Kyros","Super Rare"],
["OP10-047","Koala","Uncommon"],
["OP10-048","Sai","Common"],
["OP10-049","Sabo","Rare"],
["OP10-050","Hajrudin","Common"],
["OP10-051","Hack","Uncommon"],
["OP10-052","Bartolomeo","Common"],
["OP10-053","Bian","Common"],
["OP10-054","Blue Gilly","Common"],
["OP10-055","Marco","Rare"],
["OP10-056","Mansherry","Uncommon"],
["OP10-057","Leo","Rare"],
["OP10-058","Rebecca","Super Rare"],
["OP10-059","Fo...llow...Me...and...I...Will...Gui...de...You","Rare"],
["OP10-060","Barrier-Barrier Pistol","Common"],
["OP10-061","Special Long-Range Attack!! Bagworm","Uncommon"],
["OP10-062","Violet","Rare"],
["OP10-063","Vinsmoke Sanji","Rare"],
["OP10-064","Clone Soldier","Common"],
["OP10-065","Sugar","Rare"],
["OP10-066","Giolla","Uncommon"],
["OP10-067","Senor Pink","Rare"],
["OP10-068","Diamante","Common"],
["OP10-069","Fighting Fish","Common"],
["OP10-070","Trebol","Common"],
["OP10-071","Donquixote Doflamingo","Super Rare"],
["OP10-072","Donquixote Rosinante","Super Rare"],
["OP10-073","Buffalo","Common"],
["OP10-074","Pica","Uncommon"],
["OP10-075","Foxy","Uncommon"],
["OP10-076","Baby 5","Uncommon"],
["OP10-077","Bellamy","Common"],
["OP10-078","I Do Not Forgive Those Who Laugh at My Family!!!","Rare"],
["OP10-079","God Thread","Uncommon"],
["OP10-080","Little Black Bears","Common"],
["OP10-081","Usopp","Common"],
["OP10-082","Kuzan","Super Rare"],
["OP10-083","Kouzuki Momonosuke","Uncommon"],
["OP10-084","Sanjuan.Wolf","Common"],
["OP10-085","Jesus Burgess","Uncommon"],
["OP10-086","Shiryu","Rare"],
["OP10-087","Tony Tony.Chopper","Uncommon"],
["OP10-088","Nami","Uncommon"],
["OP10-089","Nico Robin","Common"],
["OP10-090","Franky","Rare"],
["OP10-091","Brook","Common"],
["OP10-092","Perona","Common"],
["OP10-093","Saint Homing","Common"],
["OP10-094","Ryuma","Uncommon"],
["OP10-095","Roronoa Zoro","Rare"],
["OP10-096","There’s No Longer Any Need for the Seven Warlords of the Sea!!!","Uncommon"],
["OP10-097","Gum-Gum Rhino Schneider","Common"],
["OP10-098","Liberation","Rare"],
["OP10-099","Eustass\"Captain\"Kid","Leader"],
["OP10-100","Inazuma","Common"],
["OP10-101","Urouge","Common"],
["OP10-102","Emporio.Ivankov","Common"],
["OP10-103","Capone\"Gang\"Bege","Rare"],
["OP10-104","Caribou","Uncommon"],
["OP10-105","Cavendish","Common"],
["OP10-106","Killer","Uncommon"],
["OP10-107","Jewelry Bonney","Uncommon"],
["OP10-108","Scratchmen Apoo","Common"],
["OP10-109","Basil Hawkins","Rare"],
["OP10-110","Heat & Wire","Common"],
["OP10-111","Monkey.D.Luffy","Rare"],
["OP10-112","Eustass\"Captain\"Kid","Super Rare"],
["OP10-113","Roronoa Zoro","Uncommon"],
["OP10-114","X.Drake","Uncommon"],
["OP10-115","Let's Meet Again in the New World","Common"],
["OP10-116","Damned Punk","Rare"],
["OP10-117","ROOM","Uncommon"],
["OP10-118","Monkey.D.Luffy","Secret Rare"],
["OP10-119","Trafalgar Law","Secret Rare"],
["OP10-005_p1","Sanji",""],
["OP10-016_p1","Monet",""],
["OP10-030_p1","Smoker",""],
["OP10-032_p1","Tashigi",""],
["OP10-037_p1","Lim",""],
["OP10-045_p1","Cavendish",""],
["OP10-046_p1","Kyros",""],
["OP10-058_p1","Rebecca",""],
["OP10-067_p1","Senor Pink",""],
["OP10-071_p1","Donquixote Doflamingo",""],
["OP10-072_p1","Donquixote Rosinante",""],
["OP10-082_p1","Kuzan",""],
["OP10-090_p1","Franky",""],
["OP10-111_p1","Monkey.D.Luffy",""],
["OP10-112_p1","Eustass\"Captain\"Kid",""],
["OP10-118_p1","Monkey.D.Luffy",""],
["OP10-119_p1","Trafalgar Law",""],
["OP10-019_p1","Divine Departure",""],
["OP10-001_p1","Smoker",""],
["OP10-002_p1","Caesar Clown",""],
["OP10-003_p1","Sugar",""],
["OP10-022_p1","Trafalgar Law",""],
["OP10-042_p1","Usopp",""],
["OP10-099_p1","Eustass\"Captain\"Kid",""],
["OP10-119_p2","Trafalgar Law",""],
["EB01-056_p2","Charlotte Flampe","Special Card"],
["OP07-021_p1","Urouge","Special Card"],
["ST12-012_p1","Charlotte Pudding","Special Card"],
["ST14-003_p1","Sanji","Special Card"],
["ST15-002_p1","Edward.Newgate","Special Card"],
["ST18-001_p1","Uso-Hachi","Special Card"],
["OP08-052_p2","Portgas.D.Ace","Treasure Rare"],
["OP11-001","Koby","Leader"],
["OP11-002","Ain","Common"],
["OP11-003","Usopp","Uncommon"],
["OP11-004","Kujyaku","Super Rare"],
["OP11-005","Smoker","Common"],
["OP11-006","Zephyr","Common"],
["OP11-007","Tashigi","Common"],
["OP11-008","Doll","Rare"],
["OP11-009","Nico Robin","Common"],
["OP11-010","Hibari","Super Rare"],
["OP11-011","Bins","Common"],
["OP11-012","Franky","Uncommon"],
["OP11-013","Prince Grus","Rare"],
["OP11-014","Borsalino","Rare"],
["OP11-015","Mocha","Common"],
["OP11-016","Roronoa Zoro","Uncommon"],
["OP11-017","X.Drake","Uncommon"],
["OP11-018","Honesty Impact","Rare"],
["OP11-019","Glorp Web!!","Common"],
["OP11-020","X Calibur","Uncommon"],
["OP11-021","Jinbe","Leader"],
["OP11-022","Shirahoshi","Leader"],
["OP11-023","Arlong","Rare"],
["OP11-024","Aladine","Common"],
["OP11-025","Ishilly","Common"],
["OP11-026","Scaled Neptunian","Common"],
["OP11-027","Bulge-Eyed Neptunian","Common"],
["OP11-028","Lord of the Coast","Rare"],
["OP11-029","Charlotte Praline","Uncommon"],
["OP11-030","Shirahoshi","Rare"],
["OP11-031","Jinbe","Super Rare"],
["OP11-032","Surume","Uncommon"],
["OP11-033","Bird Neptunian","Uncommon"],
["OP11-034","Hatchan","Common"],
["OP11-035","Fisher Tiger","Common"],
["OP11-036","Spotted Neptunian","Uncommon"],
["OP11-037","Ancient Weapon Poseidon","Uncommon"],
["OP11-038","Gum-Gum Elephant Gatling","Rare"],
["OP11-039","Vagabond Drill","Common"],
["OP11-040","Monkey.D.Luffy","Leader"],
["OP11-041","Nami","Leader"],
["OP11-042","Vito","Common"],
["OP11-043","Vinsmoke Ichiji","Common"],
["OP11-044","Vinsmoke Judge","Common"],
["OP11-045","Vinsmoke Niji","Uncommon"],
["OP11-046","Vinsmoke Yonji","Common"],
["OP11-047","Vinsmoke Reiju","Rare"],
["OP11-048","Capone\"Gang\"Bege","Rare"],
["OP11-049","Carrot","Rare"],
["OP11-050","Gotti","Common"],
["OP11-051","Sanji","Super Rare"],
["OP11-052","Charlotte Lola","Common"],
["OP11-053","Tony Tony.Chopper","Uncommon"],
["OP11-054","Nami","Super Rare"],
["OP11-055","Bartolomeo","Uncommon"],
["OP11-056","Brook","Rare"],
["OP11-057","Pedro","Common"],
["OP11-058","Monkey.D.Luffy","Uncommon"],
["OP11-059","Gum-Gum King Cobra","Common"],
["OP11-060","Let's Crash This Wedding!!!","Rare"],
["OP11-061","Gum-Gum Jet Culverin","Uncommon"],
["OP11-062","Charlotte Katakuri","Leader"],
["OP11-063","Little Sadi","Common"],
["OP11-064","Saldeath","Common"],
["OP11-065","Charlotte Anana","Uncommon"],
["OP11-066","Charlotte Oven","Rare"],
["OP11-067","Charlotte Katakuri","Super Rare"],
["OP11-068","Charlotte Daifuku","Uncommon"],
["OP11-069","Charlotte Brulee","Rare"],
["OP11-070","Charlotte Pudding","Super Rare"],
["OP11-071","Charlotte Perospero","Rare"],
["OP11-072","Charlotte Mont-d'or","Uncommon"],
["OP11-073","Charlotte Linlin","Rare"],
["OP11-074","Streusen","Common"],
["OP11-075","Jaguar.D.Saul","Common"],
["OP11-076","Hannyabal","Common"],
["OP11-077","Randolph","Common"],
["OP11-078","Decuplets","Uncommon"],
["OP11-079","When Two Men Are Fighting the Last Thing I Need Is Some Half-Hearted Assistance!!!!","Uncommon"],
["OP11-080","Gear Two","Rare"],
["OP11-081","Cognac Mama-Mash","Common"],
["OP11-082","Aramaki","Rare"],
["OP11-083","Caribou","Rare"],
["OP11-084","Kuzan","Rare"],
["OP11-085","Kurozumi Orochi","Common"],
["OP11-086","Coribou","Common"],
["OP11-087","Miss Sarahebi","Uncommon"],
["OP11-088","Shu","Common"],
["OP11-089","Black Maria","Common"],
["OP11-090","Briscola","Common"],
["OP11-091","Berry Good","Uncommon"],
["OP11-092","Helmeppo","Super Rare"],
["OP11-093","Bogard","Uncommon"],
["OP11-094","Morgan","Common"],
["OP11-095","Monkey.D.Garp","Super Rare"],
["OP11-096","Ripper","Uncommon"],
["OP11-097","After All These Years I'm Losing My Edge!!!","Uncommon"],
["OP11-098","Blue Hole","Common"],
["OP11-099","I'm Gonna Be a Navy Officer!!!","Rare"],
["OP11-100","Otohime","Common"],
["OP11-101","Capone\"Gang\"Bege","Super Rare"],
["OP11-102","Camie","Uncommon"],
["OP11-103","Long-Jaw Neptunian","Common"],
["OP11-104","Shirley","Rare"],
["OP11-105","Charlotte Chiffon","Uncommon"],
["OP11-106","Zeus","Rare"],
["OP11-107","Topknot Neptunian","Common"],
["OP11-108","Neptune","Rare"],
["OP11-109","Pappag","Common"],
["OP11-110","Fukaboshi","Common"],
["OP11-111","Mamboshi","Uncommon"],
["OP11-112","Megalo","Uncommon"],
["OP11-113","Ryuboshi","Common"],
["OP11-114","Gum-Gum Fire-Fist Pistol Red Hawk","Rare"],
["OP11-115","You're Just Not My Type!","Uncommon"],
["OP11-116","Merman Combat Ultramarine","Common"],
["OP11-117","Fish-Man Island","Common"],
["OP11-118","Monkey.D.Luffy","Secret Rare"],
["OP11-119","Koby","Secret Rare"],
["OP11-004_p1","Kujyaku",""],
["OP11-008_p1","Doll",""],
["OP11-010_p1","Hibari",""],
["OP11-023_p1","Arlong",""],
["OP11-031_p1","Jinbe",""],
["OP11-047_p1","Vinsmoke Reiju",""],
["OP11-051_p1","Sanji",""],
["OP11-054_p1","Nami",""],
["OP11-067_p1","Charlotte Katakuri",""],
["OP11-070_p1","Charlotte Pudding",""],
["OP11-073_p1","Charlotte Linlin",""],
["OP11-084_p1","Kuzan",""],
["OP11-092_p1","Helmeppo",""],
["OP11-095_p1","Monkey.D.Garp",""],
["OP11-101_p1","Capone\"Gang\"Bege",""],
["OP11-106_p1","Zeus",""],
["OP11-118_p1","Monkey.D.Luffy",""],
["OP11-119_p1","Koby",""],
["OP11-018_p1","Honesty Impact",""],
["OP11-080_p1","Gear Two",""],
["OP11-114_p1","Gum-Gum Fire-Fist Pistol Red Hawk",""],
["OP11-001_p1","Koby",""],
["OP11-021_p1","Jinbe",""],
["OP11-022_p1","Shirahoshi",""],
["OP11-040_p1","Monkey.D.Luffy",""],
["OP11-041_p1","Nami",""],
["OP11-062_p1","Charlotte Katakuri",""],
["OP11-118_p2","Monkey.D.Luffy",""],
["EB01-057_p2","Shirahoshi","Special Card"],
["OP06-119_p2","Sanji","Special Card"],
["OP07-085_p2","Stussy","Special Card"],
["OP09-005_p1","Silvers Rayleigh","Special Card"],
["ST16-004_p1","Shanks","Special Card"],
["ST18-005_p1","Luffy-Tarou","Special Card"],
["OP05-119_p5","Monkey.D.Luffy","Special Card"],
["OP05-119_p6","Monkey.D.Luffy","Special Card"],
["OP09-015_p1","Lucky.Roux","Treasure Rare"],
["OP12-001","Silvers Rayleigh","Leader"],
["OP12-002","Edward.Newgate","Uncommon"],
["OP12-003","Crocus","Uncommon"],
["OP12-004","Kouzuki Oden","Uncommon"],
["OP12-005","Shiki","Common"],
["OP12-006","Shakuyaku","Rare"],
["OP12-007","Shanks","Common"],
["OP12-008","Shanks","Rare"],
["OP12-009","Jinbe","Rare"],
["OP12-010","Douglas Bullet","Uncommon"],
["OP12-011","Duval","Common"],
["OP12-012","Buggy","Common"],
["OP12-013","Hatchan","Common"],
["OP12-014","Boa Hancock","Super Rare"],
["OP12-015","Monkey.D.Luffy","Super Rare"],
["OP12-016","To Never Doubt--That Is Power!","Common"],
["OP12-017","Color of Observation Haki","Uncommon"],
["OP12-018","Color of the Supreme King Haki","Rare"],
["OP12-019","Color of Arms Haki","Common"],
["OP12-020","Roronoa Zoro","Leader"],
["OP12-021","Ipponmatsu","Common"],
["OP12-022","Inuarashi","Common"],
["OP12-023","Kawamatsu","Uncommon"],
["OP12-024","Gyukimaru","Common"],
["OP12-025","Kin'emon","Common"],
["OP12-026","Kuina","Uncommon"],
["OP12-027","Koushirou","Uncommon"],
["OP12-028","Kouzuki Hiyori","Rare"],
["OP12-029","Shimotsuki Kouzaburou","Uncommon"],
["OP12-030","Dracule Mihawk","Super Rare"],
["OP12-031","Tashigi","Rare"],
["OP12-032","Nekomamushi","Uncommon"],
["OP12-033","Helmeppo","Common"],
["OP12-034","Perona","Super Rare"],
["OP12-035","Morgan","Common"],
["OP12-036","Roronoa Zoro","Common"],
["OP12-037","Demon Aura Nine Sword Style Asura Blades Drawn Dead Man's Game","Rare"],
["OP12-038","Two-Sword Style Rashomon","Common"],
["OP12-039","Luffy Is the Man Who Will Become the King of Pirates!!!","Rare"],
["OP12-040","Kuzan","Leader"],
["OP12-041","Sanji","Leader"],
["OP12-042","Alvida","Common"],
["OP12-043","Kuzan","Rare"],
["OP12-044","Sakazuki","Rare"],
["OP12-045","Jango","Common"],
["OP12-046","Zephyr(Navy)","Common"],
["OP12-047","Sengoku","Rare"],
["OP12-048","Donquixote Rosinante","Common"],
["OP12-049","Buggy","Uncommon"],
["OP12-050","Jaguar.D.Saul","Uncommon"],
["OP12-051","Hina","Uncommon"],
["OP12-052","Fullbody","Common"],
["OP12-053","Borsalino","Rare"],
["OP12-054","Marshall.D.Teach","Common"],
["OP12-055","Mohji & Cabaji","Uncommon"],
["OP12-056","Monkey.D.Garp","Super Rare"],
["OP12-057","Ice Block Pheasant Peck","Common"],
["OP12-058","I Will Make Whitebeard the King of the Pirates","Common"],
["OP12-059","Concasser","Uncommon"],
["OP12-060","Boeuf Burst","Rare"],
["OP12-061","Donquixote Rosinante","Leader"],
["OP12-062","Vinsmoke Sora","Rare"],
["OP12-063","Vinsmoke Reiju","Super Rare"],
["OP12-064","Vergo","Common"],
["OP12-065","Emporio.Ivankov","Uncommon"],
["OP12-066","Carne","Common"],
["OP12-067","Carmen","Common"],
["OP12-068","Gin","Uncommon"],
["OP12-069","Crocodile","Common"],
["OP12-070","Sanji","Rare"],
["OP12-071","Charlotte Pudding","Rare"],
["OP12-072","Zeff","Uncommon"],
["OP12-073","Trafalgar Law","Super Rare"],
["OP12-074","Patty","Common"],
["OP12-075","Ms. All Sunday","Common"],
["OP12-076","Monet","Uncommon"],
["OP12-077","The \"Extinguishes All Sound Created by Your Influence\" Technique","Common"],
["OP12-078","Brochette Blow","Uncommon"],
["OP12-079","Luffy Is the Man Who Will Be King of the Pirates!!!","Rare"],
["OP12-080","Baratie","Common"],
["OP12-081","Koala","Leader"],
["OP12-082","Issho","Common"],
["OP12-083","Inazuma","Uncommon"],
["OP12-084","Emporio.Ivankov","Uncommon"],
["OP12-085","Karasu","Common"],
["OP12-086","Koala","Rare"],
["OP12-087","Nico Robin","Super Rare"],
["OP12-088","Bastille","Common"],
["OP12-089","Hack","Rare"],
["OP12-090","Belo Betty","Common"],
["OP12-091","Poker","Common"],
["OP12-092","Mizerka","Uncommon"],
["OP12-093","Morley","Uncommon"],
["OP12-094","Monkey.D.Dragon","Super Rare"],
["OP12-095","Lindbergh","Common"],
["OP12-096","Ursa Shock","Common"],
["OP12-097","Captains Assembled","Rare"],
["OP12-098","Hair Removal Fist","Uncommon"],
["OP12-099","Kalgara","Rare"],
["OP12-100","Sabo","Rare"],
["OP12-101","Jewelry Bonney","Common"],
["OP12-102","Shirahoshi","Super Rare"],
["OP12-103","Seto","Uncommon"],
["OP12-104","Sentomaru","Common"],
["OP12-105","Trafalgar Lammy","Common"],
["OP12-106","Trafalgar Law","Uncommon"],
["OP12-107","Donquixote Doflamingo","Rare"],
["OP12-108","Donquixote Rosinante","Rare"],
["OP12-109","Pacifista","Common"],
["OP12-110","Buffalo","Common"],
["OP12-111","Baby 5","Common"],
["OP12-112","Baby 5","Rare"],
["OP12-113","Roronoa Zoro","Uncommon"],
["OP12-114","Wyper","Uncommon"],
["OP12-115","I Love You!!","Uncommon"],
["OP12-116","We'll Ring the Bell Waiting for You!!","Common"],
["OP12-117","Slam Gibson","Rare"],
["OP12-118","Jewelry Bonney","Secret Rare"],
["OP12-119","Bartholomew Kuma","Secret Rare"],
["OP12-008_p1","Shanks",""],
["OP12-014_p1","Boa Hancock",""],
["OP12-015_p1","Monkey.D.Luffy",""],
["OP12-030_p1","Dracule Mihawk",""],
["OP12-031_p1","Tashigi",""],
["OP12-034_p1","Perona",""],
["OP12-043_p1","Kuzan",""],
["OP12-056_p1","Monkey.D.Garp",""],
["OP12-063_p1","Vinsmoke Reiju",""],
["OP12-070_p1","Sanji",""],
["OP12-073_p1","Trafalgar Law",""],
["OP12-086_p1","Koala",""],
["OP12-087_p1","Nico Robin",""],
["OP12-094_p1","Monkey.D.Dragon",""],
["OP12-102_p1","Shirahoshi",""],
["OP12-108_p1","Donquixote Rosinante",""],
["OP12-118_p1","Jewelry Bonney",""],
["OP12-119_p1","Bartholomew Kuma",""],
["OP12-037_p1","Demon Aura Nine Sword Style Asura Blades Drawn Dead Man's Game",""],
["OP12-060_p1","Boeuf Burst",""],
["OP12-001_p1","Silvers Rayleigh",""],
["OP12-020_p1","Roronoa Zoro",""],
["OP12-040_p1","Kuzan",""],
["OP12-041_p1","Sanji",""],
["OP12-061_p1","Donquixote Rosinante",""],
["OP12-081_p1","Koala",""],
["OP12-118_p2","Jewelry Bonney",""],
["OP06-050_p2","Tashigi","Special Card"],
["OP09-013_p1","Yasopp","Special Card"],
["OP09-037_p2","Lim","Special Card"],
["OP10-082_p2","Kuzan","Special Card"],
["ST13-011_p2","Portgas.D.Ace","Special Card"],
["ST18-004_p2","Zoro-Juurou","Special Card"],
["OP09-093_p4","Marshall.D.Teach","Special Card"],
["OP09-093_p5","Marshall.D.Teach","Special Card"],
["OP10-063_p1","Vinsmoke Sanji","Treasure Rare"],
["OP13-001","Monkey.D.Luffy","Leader"],
["OP13-002","Portgas.D.Ace","Leader"],
["OP13-003","Gol.D.Roger","Leader"],
["OP13-004","Sabo","Leader"],
["OP13-005","Inazuma","Uncommon"],
["OP13-006","Woop Slap","Common"],
["OP13-007","Ace & Sabo & Luffy","Super Rare"],
["OP13-008","Emporio.Ivankov","Common"],
["OP13-009","Curly.Dadan","Common"],
["OP13-010","Lord of the Coast","Common"],
["OP13-011","Nefeltari Cobra","Uncommon"],
["OP13-012","Nefeltari Vivi","Rare"],
["OP13-013","Higuma","Common"],
["OP13-014","Portgas.D.Rouge","Common"],
["OP13-015","Makino","Uncommon"],
["OP13-016","Monkey.D.Garp","Rare"],
["OP13-017","Monkey.D.Dragon","Rare"],
["OP13-018","Wapol","Uncommon"],
["OP13-019","But Ace Here Said You Deserved It!!","Rare"],
["OP13-020","Meteor Fist","Uncommon"],
["OP13-021","Gum-Gum Gatling Gun","Common"],
["OP13-022","Windmill Village","Common"],
["OP13-023","Uta","Super Rare"],
["OP13-024","Gordon","Common"],
["OP13-025","Koby","Common"],
["OP13-026","Sunny-Kun","Common"],
["OP13-027","Sanji","Rare"],
["OP13-028","Shanks","Super Rare"],
["OP13-029","Jinbe","Uncommon"],
["OP13-030","Tony Tony.Chopper","Uncommon"],
["OP13-031","Trafalgar Law","Rare"],
["OP13-032","Nico Robin","Uncommon"],
["OP13-033","Franky","Common"],
["OP13-034","Brook","Common"],
["OP13-035","Bepo","Common"],
["OP13-036","Helmeppo","Uncommon"],
["OP13-037","Roronoa Zoro","Rare"],
["OP13-038","Gum-Gum Elephant Gun","Uncommon"],
["OP13-039","Gum-Gum Snake Shot","Common"],
["OP13-040","I Know You're Strong... So I'll Go All Out from the Very Start!!!","Rare"],
["OP13-041","Izo","Uncommon"],
["OP13-042","Edward.Newgate","Super Rare"],
["OP13-043","Otama","Rare"],
["OP13-044","Curiel","Common"],
["OP13-045","Haruta","Common"],
["OP13-046","Vista","Rare"],
["OP13-047","Fossa","Common"],
["OP13-048","Blamenco","Uncommon"],
["OP13-049","Blenheim","Uncommon"],
["OP13-050","Boa Sandersonia","Common"],
["OP13-051","Boa Hancock","Rare"],
["OP13-052","Boa Marigold","Uncommon"],
["OP13-053","Marshall.D.Teach","Common"],
["OP13-054","Yamato","Super Rare"],
["OP13-055","Rakuyo","Common"],
["OP13-056","LittleOars Jr.","Common"],
["OP13-057","If I Bowed Down to Power, What's the Point in Living?","Rare"],
["OP13-058","Phoenix Pyreapple","Uncommon"],
["OP13-059","Brilliant Punk","Common"],
["OP13-060","Amatsuki Toki","Common"],
["OP13-061","Inuarashi","Common"],
["OP13-062","Crocus","Uncommon"],
["OP13-063","Kouzuki Oden","Uncommon"],
["OP13-064","Gol.D.Roger","Super Rare"],
["OP13-065","Shanks","Rare"],
["OP13-066","Silvers Rayleigh","Super Rare"],
["OP13-067","Scopper Gaban","Rare"],
["OP13-068","Douglas Bullet","Common"],
["OP13-069","Tom","Common"],
["OP13-070","Napoleon","Common"],
["OP13-071","Nekomamushi","Uncommon"],
["OP13-072","Buggy","Rare"],
["OP13-073","Prometheus","Uncommon"],
["OP13-074","Hera","Common"],
["OP13-075","Guess We'll Have Another Scrap. You Can Only Risk Death While You're Still Alive!!","Uncommon"],
["OP13-076","Divine Departure","Rare"],
["OP13-077","Go All the Way to the Top!!","Common"],
["OP13-078","Oro Jackson","Common"],
["OP13-079","Imu","Leader"],
["OP13-080","St. Ethanbaron V. Nusjuro","Rare"],
["OP13-081","Koala","Common"],
["OP13-082","Five Elders","Super Rare"],
["OP13-083","St. Jaygarcia Saturn","Rare"],
["OP13-084","St. Shepherd Ju Peter","Rare"],
["OP13-085","Saint Jalmac","Common"],
["OP13-086","Saint Shalria","Uncommon"],
["OP13-087","Saint Charlos","Uncommon"],
["OP13-088","Terry Gilteo","Uncommon"],
["OP13-089","St. Topman Warcury","Rare"],
["OP13-090","Hack","Uncommon"],
["OP13-091","St. Marcus Mars","Rare"],
["OP13-092","Saint Mjosgard","Common"],
["OP13-093","Morgans","Common"],
["OP13-094","York","Common"],
["OP13-095","Saint Rosward","Common"],
["OP13-096","The Five Elders Are at Your Service!!!","Rare"],
["OP13-097","The World's Equilibrium Cannot Be Maintained Forever","Common"],
["OP13-098","Never Existed... in the First Place...","Uncommon"],
["OP13-099","The Empty Throne","Common"],
["OP13-100","Jewelry Bonney","Leader"],
["OP13-101","Atlas","Uncommon"],
["OP13-102","Edison","Uncommon"],
["OP13-103","Gyogyo","Common"],
["OP13-104","Kouzuki Hiyori","Rare"],
["OP13-105","Kouzuki Momonosuke","Common"],
["OP13-106","Conney","Common"],
["OP13-107","Shaka","Common"],
["OP13-108","Jewelry Bonney","Super Rare"],
["OP13-109","Jewelry Bonney","Uncommon"],
["OP13-110","Stussy","Super Rare"],
["OP13-111","Pythagoras","Uncommon"],
["OP13-112","Vegapunk","Common"],
["OP13-113","Lilith","Rare"],
["OP13-114","S-Snake","Rare"],
["OP13-115","Paper Art Afterimage","Common"],
["OP13-116","The One Who Is the Most Free Is the Pirate King!!!","Uncommon"],
["OP13-117","Gum-Gum Dawn Stamp","Rare"],
["OP13-118","Monkey.D.Luffy","Secret Rare"],
["OP13-119","Portgas.D.Ace","Secret Rare"],
["OP13-120","Sabo","Secret Rare"],
["OP13-007_p1","Ace & Sabo & Luffy",""],
["OP13-016_p1","Monkey.D.Garp",""],
["OP13-023_p1","Uta",""],
["OP13-027_p1","Sanji",""],
["OP13-028_p1","Shanks",""],
["OP13-042_p1","Edward.Newgate",""],
["OP13-051_p1","Boa Hancock",""],
["OP13-054_p1","Yamato",""],
["OP13-064_p1","Gol.D.Roger",""],
["OP13-065_p1","Shanks",""],
["OP13-066_p1","Silvers Rayleigh",""],
["OP13-080_p1","St. Ethanbaron V. Nusjuro",""],
["OP13-082_p1","Five Elders",""],
["OP13-083_p1","St. Jaygarcia Saturn",""],
["OP13-084_p1","St. Shepherd Ju Peter",""],
["OP13-089_p1","St. Topman Warcury",""],
["OP13-091_p1","St. Marcus Mars",""],
["OP13-108_p1","Jewelry Bonney",""],
["OP13-110_p1","Stussy",""],
["OP13-113_p1","Lilith",""],
["OP13-114_p1","S-Snake",""],
["OP13-118_p1","Monkey.D.Luffy",""],
["OP13-119_p1","Portgas.D.Ace",""],
["OP13-120_p1","Sabo",""],
["OP13-076_p1","Divine Departure",""],
["OP13-001_p1","Monkey.D.Luffy",""],
["OP13-002_p1","Portgas.D.Ace",""],
["OP13-003_p1","Gol.D.Roger",""],
["OP13-004_p1","Sabo",""],
["OP13-079_p1","Imu",""],
["OP13-100_p1","Jewelry Bonney",""],
["OP13-080_p2","St. Ethanbaron V. Nusjuro",""],
["OP13-083_p2","St. Jaygarcia Saturn",""],
["OP13-084_p2","St. Shepherd Ju Peter",""],
["OP13-089_p2","St. Topman Warcury",""],
["OP13-091_p2","St. Marcus Mars",""],
["OP13-118_p2","Monkey.D.Luffy",""],
["OP13-119_p2","Portgas.D.Ace",""],
["OP13-120_p2","Sabo",""],
["OP13-118_p3","Monkey.D.Luffy",""],
["OP13-119_p3","Portgas.D.Ace",""],
["OP13-120_p3","Sabo",""],
["OP13-118_p4","Monkey.D.Luffy","Special Card"],
["OP13-119_p4","Portgas.D.Ace","Special Card"],
["OP13-120_p4","Sabo","Special Card"],
["OP09-118_p3","Gol.D.Roger","Special Card"],
["OP09-009_p3","Benn.Beckman","Special Card"],
["OP10-030_p2","Smoker","Special Card"],
["EB02-028_p1","Portgas.D.Ace","Special Card"],
["OP09-119_p3","Monkey.D.Luffy","Special Card"],
["OP07-118_p2","Sabo","Special Card"],
["OP07-111_p2","Lilith","Special Card"],
["OP09-004_p5","Shanks","Special Card"],
["OP09-004_p6","Shanks","Special Card"],
["OP11-058_p1","Monkey.D.Luffy","Treasure Rare"],
["OP14-001","Trafalgar Law","Leader"],
["OP14-002","Urouge","Uncommon"],
["OP14-003","Capone\"Gang\"Bege","Common"],
["OP14-004","Cavendish","Uncommon"],
["OP14-005","Killer","Common"],
["OP14-006","Shachi & Penguin","Common"],
["OP14-007","Jewelry Bonney","Common"],
["OP14-008","Scratchmen Apoo","Common"],
["OP14-009","Trafalgar Law","Super Rare"],
["OP14-010","Basil Hawkins","Uncommon"],
["OP14-011","Bartolomeo","Uncommon"],
["OP14-012","Bepo","Common"],
["OP14-013","Monkey.D.Luffy","Super Rare"],
["OP14-014","Eustass\"Captain\"Kid","Rare"],
["OP14-015","Roronoa Zoro","Rare"],
["OP14-016","X.Drake","Rare"],
["OP14-017","Chambres","Common"],
["OP14-018","Time for the Counterattack","Rare"],
["OP14-019","I Have a Plan to Take Down One of the Four Emperors!!","Uncommon"],
["OP14-020","Dracule Mihawk","Leader"],
["OP14-021","Issho","Common"],
["OP14-022","Usopp","Uncommon"],
["OP14-023","Kikunojo","Rare"],
["OP14-024","Kin'emon","Common"],
["OP14-025","Kuro","Common"],
["OP14-026","Kouzuki Oden","Uncommon"],
["OP14-027","Shanks","Rare"],
["OP14-028","Johnny","Common"],
["OP14-029","Tashigi","Rare"],
["OP14-030","Chaka & Pell","Common"],
["OP14-031","Nami","Super Rare"],
["OP14-032","Humandrill","Uncommon"],
["OP14-033","Perona","Super Rare"],
["OP14-034","Monkey.D.Luffy","Rare"],
["OP14-035","Yosaku","Common"],
["OP14-036","Strive to Surpass me, Roronoa Zoro!!!","Common"],
["OP14-037","For Fun","Rare"],
["OP14-038","I Never Bother to Remember the Faces of Trash","Uncommon"],
["OP14-039","Coffin Boat","Uncommon"],
["OP14-040","Jinbe","Leader"],
["OP14-041","Boa Hancock","Leader"],
["OP14-042","Arlong","Rare"],
["OP14-043","Aladine","Rare"],
["OP14-044","Edward.Newgate","Common"],
["OP14-045","Kuroobi","Uncommon"],
["OP14-046","Koala","Uncommon"],
["OP14-047","Shirahoshi","Rare"],
["OP14-048","Shiryu","Common"],
["OP14-049","Jinbe","Super Rare"],
["OP14-050","Chew","Uncommon"],
["OP14-051","Hatchan","Common"],
["OP14-052","Hannyabal","Common"],
["OP14-053","Vista","Common"],
["OP14-054","Fisher Tiger","Uncommon"],
["OP14-055","The Macro Gang","Common"],
["OP14-056","Wadatsumi","Common"],
["OP14-057","Don't Worry!! I'm Here!!","Common"],
["OP14-058","Ocean Current Shoulder Throw","Rare"],
["OP14-059","Please Take Me with You!! I Can Be of Great Help to You!!","Uncommon"],
["OP14-060","Donquixote Doflamingo","Leader"],
["OP14-061","Vergo","Rare"],
["OP14-062","Gladius","Common"],
["OP14-063","Sugar","Rare"],
["OP14-064","Giolla","Common"],
["OP14-065","Senor Pink","Common"],
["OP14-066","Diamante","Common"],
["OP14-067","Dellinger","Uncommon"],
["OP14-068","Trebol","Uncommon"],
["OP14-069","Donquixote Doflamingo","Super Rare"],
["OP14-070","Buffalo","Common"],
["OP14-071","Pica","Uncommon"],
["OP14-072","Baby 5","Uncommon"],
["OP14-073","Machvise","Common"],
["OP14-074","Monet","Rare"],
["OP14-075","Lao.G","Common"],
["OP14-076","Ever White","Rare"],
["OP14-077","Penta-Chromatic String","Uncommon"],
["OP14-078","Bullet String","Common"],
["OP14-079","Crocodile","Leader"],
["OP14-080","Gecko Moria","Leader"],
["OP14-081","Spider Mice","Common"],
["OP14-082","Oinkchuck","Common"],
["OP14-083","Ms. Wednesday","Uncommon"],
["OP14-084","Ms. All Sunday","Super Rare"],
["OP14-085","Miss.Goldenweek(Marianne)","Uncommon"],
["OP14-086","Miss Doublefinger(Zala)","Common"],
["OP14-087","Miss.Valentine(Mikita)","Rare"],
["OP14-088","Miss.MerryChristmas(Drophy)","Common"],
["OP14-089","Ryuma","Common"],
["OP14-090","Mr.1(Daz.Bonez)","Rare"],
["OP14-091","Mr.2.Bon.Kurei(Bentham)","Super Rare"],
["OP14-092","Mr.3(Galdino)","Rare"],
["OP14-093","Mr.4(Babe)","Common"],
["OP14-094","Mr.5(Gem)","Uncommon"],
["OP14-095","Mr.9","Common"],
["OP14-096","Ground Death","Rare"],
["OP14-097","Hurry Up and Make Me the Pirate King!","Uncommon"],
["OP14-098","Crescent Cutlass","Common"],
["OP14-099","Disappointed?","Uncommon"],
["OP14-100","Absalom","Rare"],
["OP14-101","Oars","Common"],
["OP14-102","Kumacy","Common"],
["OP14-103","Gloriosa (Grandma Nyon)","Common"],
["OP14-104","Gecko Moria","Super Rare"],
["OP14-105","Gorgon Sisters","Uncommon"],
["OP14-106","Salome","Common"],
["OP14-107","Shakuyaku","Uncommon"],
["OP14-108","Silvers Rayleigh","Rare"],
["OP14-109","Victoria Cindry","Common"],
["OP14-110","Dr. Hogback","Rare"],
["OP14-111","Perona","Rare"],
["OP14-112","Boa Hancock","Super Rare"],
["OP14-113","Marguerite","Uncommon"],
["OP14-114","Ran","Uncommon"],
["OP14-115","Rindo","Common"],
["OP14-116","Salamander","Common"],
["OP14-117","Brick Bat","Uncommon"],
["OP14-118","You'll Frighten Me... ♡","Rare"],
["OP14-119","Dracule Mihawk","Secret Rare"],
["OP14-120","Crocodile","Secret Rare"],
["OP14-009_p1","Trafalgar Law",""],
["OP14-013_p1","Monkey.D.Luffy",""],
["OP14-015_p1","Roronoa Zoro",""],
["OP14-027_p1","Shanks",""],
["OP14-031_p1","Nami",""],
["OP14-033_p1","Perona",""],
["OP14-042_p1","Arlong",""],
["OP14-049_p1","Jinbe",""],
["OP14-061_p1","Vergo",""],
["OP14-069_p1","Donquixote Doflamingo",""],
["OP14-084_p1","Ms. All Sunday",""],
["OP14-090_p1","Mr.1(Daz.Bonez)",""],
["OP14-091_p1","Mr.2.Bon.Kurei(Bentham)",""],
["OP14-104_p1","Gecko Moria",""],
["OP14-111_p1","Perona",""],
["OP14-112_p1","Boa Hancock",""],
["OP14-119_p1","Dracule Mihawk",""],
["OP14-120_p1","Crocodile",""],
["OP14-096_p1","Ground Death",""],
["OP14-118_p1","You'll Frighten Me... ♡",""],
["OP14-001_p1","Trafalgar Law",""],
["OP14-020_p1","Dracule Mihawk",""],
["OP14-040_p1","Jinbe",""],
["OP14-041_p1","Boa Hancock",""],
["OP14-060_p1","Donquixote Doflamingo",""],
["OP14-079_p1","Crocodile",""],
["OP14-080_p1","Gecko Moria",""],
["OP14-119_p2","Dracule Mihawk",""],
["EB01-003_p3","Kid & Killer","Special Card"],
["OP12-030_p2","Dracule Mihawk","Special Card"],
["OP07-046_p2","Sengoku","Special Card"],
["OP10-065_p1","Sugar","Special Card"],
["OP06-093_p4","Perona","Special Card"],
["OP14-112_p2","Boa Hancock","Special Card"],
["OP09-051_p4","Buggy","Special Card"],
["OP09-051_p5","Buggy","Special Card"],
["OP12-108_p2","Donquixote Rosinante","Treasure Rare"],
["EB04-011","Scaled Neptunian","Common"],
["EB04-012","Kikunojo","Super Rare"],
["EB04-013","Carrot","Super Rare"],
["EB04-014","Kozuki Sukiyaki","Common"],
["EB04-015","Jinbe","Rare"],
["EB04-016","Bird Neptunian","Common"],
["EB04-017","Mystoms","Common"],
["EB04-018","Megalo","Rare"],
["EB04-019","Eleclaw","Rare"],
["EB04-020","Shark Brick Fist","Common"],
["EB04-021","Igaram","Common"],
["EB04-022","Issho","Rare"],
["EB04-023","Chaka & Pell","Rare"],
["EB04-024","Terracotta","Common"],
["EB04-025","Nefeltari Vivi","Super Rare"],
["EB04-026","Bluegrass","Common"],
["EB04-027","Boa Hancock","Rare"],
["EB04-028","Ice Time","Rare"],
["EB04-029","I Heard the Sound...of a Lady's Teardrops Falling","Common"],
["EB04-030","Kaido","Rare"],
["EB04-031","King","Rare"],
["EB04-032","Queen","Rare"],
["EB04-033","Groggy Monsters","Common"],
["EB04-034","Charlotte Pudding","Common"],
["EB04-035","Hitokiri Kamazo","Common"],
["EB04-036","Foxy","Super Rare"],
["EB04-037","Porche","Common"],
["EB04-038","Rosinante & Law","Super Rare"],
["EB04-039","Eustass\"Captain\"Kid","Rare"],
["EB04-040","Flame Dragon Torch","Rare"],
["EB04-041","Stealth Black","Common"],
["EB04-012_p1","Kikunojo",""],
["EB04-013_p1","Carrot",""],
["EB04-018_p1","Megalo",""],
["EB04-022_p1","Issho",""],
["EB04-025_p1","Nefeltari Vivi",""],
["EB04-031_p1","King",""],
["EB04-036_p1","Foxy",""],
["EB04-038_p1","Rosinante & Law",""],
["PRB02-006_p2","Roronoa Zoro","Special Card"],
["EB01-023_p1","Edward Weevil","Special Card"],
["EB04-039_p1","Eustass\"Captain\"Kid","Special Card"],
["OP15-001","Krieg","Leader"],
["OP15-002","Lucy","Leader"],
["OP15-003","Alvida","Rare"],
["OP15-004","Sea Cat","Common"],
["OP15-005","Cabaji","Common"],
["OP15-006","Cavendish","Uncommon"],
["OP15-007","Gin","Super Rare"],
["OP15-008","Krieg","Super Rare"],
["OP15-009","Koby","Uncommon"],
["OP15-010","Nezumi","Common"],
["OP15-011","Pearl","Rare"],
["OP15-012","Buggy","Common"],
["OP15-013","Pincers","Common"],
["OP15-014","Bartolomeo","Rare"],
["OP15-015","Higuma","Common"],
["OP15-016","Fullbody","Uncommon"],
["OP15-017","Morgan","Common"],
["OP15-018","Mohji","Common"],
["OP15-019","Barrier Bulls","Uncommon"],
["OP15-020","Fire Fist","Rare"],
["OP15-021","Just Watch Me, Ace!!!","Uncommon"],
["OP15-022","Brook","Leader"],
["OP15-023","Arlong","Rare"],
["OP15-024","Usopp","Rare"],
["OP15-025","Kuro","Rare"],
["OP15-026","Jango","Uncommon"],
["OP15-027","Dracule Mihawk","Common"],
["OP15-028","Meowban Brothers","Uncommon"],
["OP15-029","Bartholomew Kuma","Common"],
["OP15-030","Hyouzou","Uncommon"],
["OP15-031","Purinpurin","Common"],
["OP15-032","Brook","Super Rare"],
["OP15-033","Hody Jones","Common"],
["OP15-034","Yorki","Common"],
["OP15-035","Laboon","Uncommon"],
["OP15-036","Ryuma","Common"],
["OP15-037","The Outcome Will Tell Us Who's Strong and Who's Weak","Uncommon"],
["OP15-038","It's an Order! Do Not Defy Me!!!","Rare"],
["OP15-039","Rebecca","Leader"],
["OP15-040","Viola","Rare"],
["OP15-041","Orlumbus","Uncommon"],
["OP15-042","Kyros","Rare"],
["OP15-043","Kelly Funk","Common"],
["OP15-044","Koala","Common"],
["OP15-045","Sai","Uncommon"],
["OP15-046","Sabo","Super Rare"],
["OP15-047","Sanji","Rare"],
["OP15-048","Chinjao","Common"],
["OP15-049","Hajrudin","Uncommon"],
["OP15-050","Bobby Funk","Common"],
["OP15-051","Monkey.D.Luffy","Uncommon"],
["OP15-052","Leo","Uncommon"],
["OP15-053","Rebecca","Super Rare"],
["OP15-054","And No One Else Can Have It! It's Our Memento of Him","Common"],
["OP15-055","Go Ahead and Use 'Em, Mr. Luffy!!!","Rare"],
["OP15-056","Would You Let Me Eat the Flame-Flame Fruit?","Common"],
["OP15-057","Dressrosa Kingdom","Common"],
["OP15-058","Enel","Leader"],
["OP15-059","Amazon","Common"],
["OP15-060","Enel","Super Rare"],
["OP15-061","Ohm","Rare"],
["OP15-062","Captain Seamars","Uncommon"],
["OP15-063","Gedatsu","Rare"],
["OP15-064","Kotori","Common"],
["OP15-065","Goro","Common"],
["OP15-066","Satori","Rare"],
["OP15-067","Shura","Rare"],
["OP15-068","Heavenly Warriors","Common"],
["OP15-069","Nola","Uncommon"],
["OP15-070","Fuza","Common"],
["OP15-071","Holly","Common"],
["OP15-072","Hotori","Common"],
["OP15-073","Yama","Common"],
["OP15-074","Varie","Uncommon"],
["OP15-075","El Thor","Uncommon"],
["OP15-076","Lightning Beast Kiten","Uncommon"],
["OP15-077","Lightning Dragon","Rare"],
["OP15-078","Mamaragan","Super Rare"],
["OP15-079","Absalom","Common"],
["OP15-080","Oars","Rare"],
["OP15-081","Sanji","Uncommon"],
["OP15-082","Charlotte Lola","Common"],
["OP15-083","Spoil","Common"],
["OP15-084","Dr. Hogback","Common"],
["OP15-085","Tony Tony.Chopper","Rare"],
["OP15-086","Nami","Super Rare"],
["OP15-087","Nico Robin","Common"],
["OP15-088","Pirates Docking Six","Rare"],
["OP15-089","Franky","Uncommon"],
["OP15-090","Perona","Uncommon"],
["OP15-091","Margarita","Common"],
["OP15-092","Monkey.D.Luffy","Rare"],
["OP15-093","The Risky Brothers","Common"],
["OP15-094","Roronoa Zoro","Uncommon"],
["OP15-095","Gum-Gum Storm","Uncommon"],
["OP15-096","Swallow Bond en Avant","Rare"],
["OP15-097","I Find It Embarrassing as a Human Being","Common"],
["OP15-098","Monkey.D.Luffy","Leader"],
["OP15-099","Urouge","Uncommon"],
["OP15-100","Kamakiri","Common"],
["OP15-101","Kalgara","Uncommon"],
["OP15-102","Gan.Fall","Rare"],
["OP15-103","Genbo","Common"],
["OP15-104","Conis","Common"],
["OP15-105","Jewelry Bonney","Uncommon"],
["OP15-106","Octoballoon","Common"],
["OP15-107","Tony Tony.Chopper","Uncommon"],
["OP15-108","Nami","Rare"],
["OP15-109","Nico Robin","Rare"],
["OP15-110","Braham","Common"],
["OP15-111","Mont Blanc Noland","Common"],
["OP15-112","Raki","Common"],
["OP15-113","Roronoa Zoro","Super Rare"],
["OP15-114","Wyper","Super Rare"],
["OP15-115","Impact Dial","Common"],
["OP15-116","Gum-Gum Golden Rifle","Rare"],
["OP15-117","Heso!!","Uncommon"],
["OP15-118","Enel","Secret Rare"],
["OP15-119","Monkey.D.Luffy","Secret Rare"],
["OP15-003_p1","Alvida",""],
["OP15-007_p1","Gin",""],
["OP15-008_p1","Krieg",""],
["OP15-025_p1","Kuro",""],
["OP15-032_p1","Brook",""],
["OP15-046_p1","Sabo",""],
["OP15-047_p1","Sanji",""],
["OP15-053_p1","Rebecca",""],
["OP15-060_p1","Enel",""],
["OP15-061_p1","Ohm",""],
["OP15-078_p1","Mamaragan",""],
["OP15-086_p1","Nami",""],
["OP15-092_p1","Monkey.D.Luffy",""],
["OP15-109_p1","Nico Robin",""],
["OP15-113_p1","Roronoa Zoro",""],
["OP15-114_p1","Wyper",""],
["OP15-118_p1","Enel",""],
["OP15-119_p1","Monkey.D.Luffy",""],
["OP15-077_p1","Lightning Dragon",""],
["OP15-116_p1","Gum-Gum Golden Rifle",""],
["OP15-001_p1","Krieg",""],
["OP15-002_p1","Lucy",""],
["OP15-022_p1","Brook",""],
["OP15-039_p1","Rebecca",""],
["OP15-058_p1","Enel",""],
["OP15-098_p1","Monkey.D.Luffy",""],
["OP15-118_p2","Enel",""],
["OP12-014_p2","Boa Hancock","Special Card"],
["OP13-031_p1","Trafalgar Law","Special Card"],
["OP13-042_p2","Edward.Newgate","Special Card"],
["ST26-005_p1","Monkey.D.Luffy","Special Card"],
["P-105_p1","Sabo","Special Card"],
["EB02-052_p2","Enel","Special Card"],
["EB04-001","Jewelry Bonney","Leader"],
["EB04-002","Jewelry Bonney","Rare"],
["EB04-003","Smoker & Tashigi","Rare"],
["EB04-004","Zeff","Common"],
["EB04-005","Trafalgar Law","Common"],
["EB04-006","Moda","Common"],
["EB04-007","Roronoa Zoro","Super Rare"],
["EB04-008","Distorted Future","Rare"],
["EB04-009","It's My Student's Farewell. I Want It to Be Proper.","Common"],
["EB04-010","Lulucia Kingdom","Common"],
["EB04-042","Alpha","Common"],
["EB04-043","Kaku","Rare"],
["EB04-044","Koby","Super Rare"],
["EB04-045","Ginny","Common"],
["EB04-046","Doll","Common"],
["EB04-047","Helmeppo","Rare"],
["EB04-048","Rob Lucci","Super Rare"],
["EB04-049","Finger Pistol Yellow Lotus","Common"],
["EB04-050","I'll Whip You Into Shape. ♡","Rare"],
["EB04-051","Emet","Common"],
["EB04-052","Sanji","Rare"],
["EB04-053","Sentomaru","Common"],
["EB04-054","Bartholomew Kuma","Rare"],
["EB04-055","Bartholomew Kuma","Common"],
["EB04-056","Pacifista","Common"],
["EB04-057","Vegapunk","Common"],
["EB04-058","Borsalino","Super Rare"],
["EB04-059","Black Rope Dragon Twister","Rare"],
["EB04-060","Gum-Gum Hawk Gatling","Common"],
["EB04-061","Monkey.D.Luffy","Secret Rare"],
["EB04-002_p1","Jewelry Bonney",""],
["EB04-007_p1","Roronoa Zoro",""],
["EB04-043_p1","Kaku",""],
["EB04-044_p1","Koby",""],
["EB04-048_p1","Rob Lucci",""],
["EB04-052_p1","Sanji",""],
["EB04-058_p1","Borsalino",""],
["EB04-061_p1","Monkey.D.Luffy",""],
["EB04-001_p1","Jewelry Bonney",""],
["EB04-044_p2","Koby",""],
["EB04-003_p1","Smoker & Tashigi","Special Card"],
["PRB02-014_p2","Sabo","Special Card"],
["OP11-106_p3","Zeus","Special Card"],
["OP13-037_p1","Roronoa Zoro","Treasure Rare"],
["OP16-001","Portgas.D.Ace","Leader"],
["OP16-002","Izo","Uncommon"],
["OP16-003","Edward.Newgate","Super Rare"],
["OP16-004","Curiel","Common"],
["OP16-005","Thatch","Uncommon"],
["OP16-006","Shanks","Common"],
["OP16-007","Jozu","Uncommon"],
["OP16-008","Squard","Common"],
["OP16-009","Speed Jil","Common"],
["OP16-010","Namule","Uncommon"],
["OP16-011","Vista","Rare"],
["OP16-012","Benn.Beckman","Rare"],
["OP16-013","McGuy","Common"],
["OP16-014","Marco","Rare"],
["OP16-015","Monkey.D.Luffy","Super Rare"],
["OP16-016","Ramba","Common"],
["OP16-017","LittleOars Jr.","Rare"],
["OP16-018","Rockstar","Common"],
["OP16-019","Let's Show 'Em What We're Made Of!!","Common"],
["OP16-020","If You're Coming with Me... Kiss Your Lives Goodbye!!","Uncommon"],
["OP16-021","Moby Dick","Rare"],
["OP16-022","Monkey.D.Luffy","Leader"],
["OP16-023","Arlong","Common"],
["OP16-024","Inazuma","Uncommon"],
["OP16-025","Bunkov","Uncommon"],
["OP16-026","Emporio.Ivankov","Super Rare"],
["OP16-027","Jinbe","Rare"],
["OP16-028","Smoker","Common"],
["OP16-029","Antlerkov","Uncommon"],
["OP16-030","Trafalgar Law","Rare"],
["OP16-031","Buggy","Uncommon"],
["OP16-032","Boa Hancock","Super Rare"],
["OP16-033","Morley","Common"],
["OP16-034","Monkey.D.Luffy","Rare"],
["OP16-035","Roronoa Zoro","Common"],
["OP16-036","Mr.2.Bon.Kurei(Bentham)","Common"],
["OP16-037","Mr.3(Galdino)","Common"],
["OP16-038","Let's Go!! To the Navy Headquarters!!","Rare"],
["OP16-039","Gum-Gum Twin Jet Pistol","Common"],
["OP16-040","Gum-Gum Hammer Rifle","Uncommon"],
["OP16-041","Buggy","Leader"],
["OP16-042","Prisoner of Impel Down","Rare"],
["OP16-043","Usopp","Uncommon"],
["OP16-044","Emporio.Ivankov","Common"],
["OP16-045","Crocodile","Uncommon"],
["OP16-046","Jinbe","Common"],
["OP16-047","Donquixote Doflamingo","Common"],
["OP16-048","Buggy","Super Rare"],
["OP16-049","Portgas.D.Ace","Common"],
["OP16-050","Miss Olive","Uncommon"],
["OP16-051","Mohji & Cabaji","Common"],
["OP16-052","Monkey.D.Luffy","Uncommon"],
["OP16-053","Roronoa Zoro","Common"],
["OP16-054","Mr.1(Daz.Bonez)","Rare"],
["OP16-055","Mr.2.Bon.Kurei(Bentham)","Rare"],
["OP16-056","Mr.3(Galdino)","Super Rare"],
["OP16-057","Captain Buggy's Our Savior!!","Common"],
["OP16-058","The Prisoners Are Rioting!!","Rare"],
["OP16-059","We'll Change This Mission from Sneaky to Flashy!","Uncommon"],
["OP16-060","Sengoku","Leader"],
["OP16-061","Older Brother Marine","Common"],
["OP16-062","Younger Brother Marine","Common"],
["OP16-063","Kuzan","Rare"],
["OP16-064","Koby","Rare"],
["OP16-065","Sakazuki","Super Rare"],
["OP16-066","Sengoku","Uncommon"],
["OP16-067","Tsuru","Uncommon"],
["OP16-068","Trafalgar Law","Common"],
["OP16-069","Donquixote Doflamingo","Common"],
["OP16-070","Donquixote Rosinante","Uncommon"],
["OP16-071","Benevolent King of the Waves","Common"],
["OP16-072","Hannyabal","Common"],
["OP16-073","Borsalino","Rare"],
["OP16-074","Magellan","Common"],
["OP16-075","Monkey.D.Garp","Common"],
["OP16-076","The Three Admirals!!","Uncommon"],
["OP16-077","\"Buddha\" Sengoku","Rare"],
["OP16-078","Marineford","Uncommon"],
["OP16-079","Yamato","Leader"],
["OP16-080","Marshall.D.Teach","Leader"],
["OP16-081","Otama","Common"],
["OP16-082","Kin'emon","Super Rare"],
["OP16-083","Kouzuki Oden","Common"],
["OP16-084","Kouzuki Momonosuke","Uncommon"],
["OP16-085","Kouzuki Momonosuke","Rare"],
["OP16-086","Sanji","Common"],
["OP16-087","Shinobu","Uncommon"],
["OP16-088","Shimotsuki Ushimaru","Common"],
["OP16-089","Dracule Mihawk","Common"],
["OP16-090","Tony Tony.Chopper","Common"],
["OP16-091","Nami","Rare"],
["OP16-092","Nico Robin","Uncommon"],
["OP16-093","Bartholomew Kuma","Common"],
["OP16-094","Portgas.D.Ace","Uncommon"],
["OP16-095","Monkey.D.Luffy","Rare"],
["OP16-096","Yamato","Rare"],
["OP16-097","Yamato","Rare"],
["OP16-098","Yamato","Super Rare"],
["OP16-099","I've Come Here... To Cut Those Chains!!!","Uncommon"],
["OP16-100","Hallowed Glacier Slash","Common"],
["OP16-101","Mahoroba","Common"],
["OP16-102","Avalo Pizarro","Uncommon"],
["OP16-103","Van Augur","Uncommon"],
["OP16-104","Catarina Devon","Rare"],
["OP16-105","Gecko Moria","Common"],
["OP16-106","Sanjuan.Wolf","Rare"],
["OP16-107","Jesus Burgess","Common"],
["OP16-108","Shiryu","Super Rare"],
["OP16-109","Doc Q","Uncommon"],
["OP16-110","Vasco Shot","Rare"],
["OP16-111","Boa Sandersonia","Common"],
["OP16-112","Boa Hancock","Common"],
["OP16-113","Boa Marigold","Uncommon"],
["OP16-114","Laffitte","Common"],
["OP16-115","Black Vortex","Uncommon"],
["OP16-116","Zehahahahaha!","Rare"],
["OP16-117","Black Hole","Common"],
["OP16-118","Portgas.D.Ace","Secret Rare"],
["OP16-119","Marshall.D.Teach","Secret Rare"],
["OP16-003_p1","Edward.Newgate",""],
["OP16-014_p1","Marco",""],
["OP16-015_p1","Monkey.D.Luffy",""],
["OP16-021_p1","Moby Dick",""],
["OP16-026_p1","Emporio.Ivankov",""],
["OP16-032_p1","Boa Hancock",""],
["OP16-034_p1","Monkey.D.Luffy",""],
["OP16-048_p1","Buggy",""],
["OP16-055_p1","Mr.2.Bon.Kurei(Bentham)",""],
["OP16-056_p1","Mr.3(Galdino)",""],
["OP16-063_p1","Kuzan",""],
["OP16-065_p1","Sakazuki",""],
["OP16-073_p1","Borsalino",""],
["OP16-082_p1","Kin'emon",""],
["OP16-085_p1","Kouzuki Momonosuke",""],
["OP16-098_p1","Yamato",""],
["OP16-108_p1","Shiryu",""],
["OP16-118_p1","Portgas.D.Ace",""],
["OP16-119_p1","Marshall.D.Teach",""],
["OP16-116_p1","Zehahahahaha!",""],
["OP16-001_p1","Portgas.D.Ace",""],
["OP16-022_p1","Monkey.D.Luffy",""],
["OP16-041_p1","Buggy",""],
["OP16-060_p1","Sengoku",""],
["OP16-079_p1","Yamato",""],
["OP16-080_p1","Marshall.D.Teach",""],
["OP16-063_p2","Kuzan",""],
["OP16-065_p2","Sakazuki",""],
["OP16-073_p2","Borsalino",""],
["ST15-005_p4","Portgas.D.Ace","Special Card"],
["OP14-029_p2","Tashigi","Special Card"],
["OP10-045_p2","Cavendish","Special Card"],
["OP11-067_p3","Charlotte Katakuri","Special Card"],
["OP14-084_p2","Ms. All Sunday","Special Card"],
["EB04-054_p1","Bartholomew Kuma","Special Card"],
["OP16-011_p1","Vista","Treasure Rare"],
["PRB01-001","Sanji","Leader"],
["PRB01-001_p1","Sanji",""],
["P-014","Koby",""],
["P-029","Bartolomeo",""],
["P-053","Nami",""],
["P-055","Monkey.D.Luffy",""],
["ST01-006","Tony Tony.Chopper","Common"],
["ST01-014","Guard Point","Common"],
["ST02-004","Capone\"Gang\"Bege","Common"],
["ST03-005","Dracule Mihawk","Common"],
["ST03-008","Trafalgar Law","Common"],
["ST03-013","Boa Hancock","Common"],
["ST04-003","Kaido","Super Rare"],
["ST04-005","Queen","Common"],
["ST04-016","Blast Breath","Common"],
["ST06-010","Helmeppo","Common"],
["ST06-014","Shockwave","Common"],
["ST07-007","Charlotte Brulee","Common"],
["ST09-014","Narikabura Arrow","Common"],
["ST10-010","Trafalgar Law","Super Rare"],
["ST12-014","Duval","Common"],
["OP01-006_p3","Otama",""],
["OP01-029_p1","Radical Beam!!",""],
["OP01-033_p4","Izo",""],
["OP01-041_p4","Kouzuki Momonosuke",""],
["OP01-052_p3","Raizo",""],
["OP02-015_p2","Makino",""],
["OP02-018_p4","Marco",""],
["OP02-089_p1","Judgment of Hell",""],
["OP02-106_p3","Tsuru",""],
["OP02-117_p1","Ice Age",""],
["OP03-003_p2","Izo",""],
["OP03-055_p1","Gum-Gum Giant Gavel",""],
["OP03-056_p1","Sanji's Pilaf",""],
["OP03-057_p1","Three Thousand Worlds",""],
["OP03-060_p1","Kalifa",""],
["OP03-079_p1","Vergo",""],
["OP03-089_p2","Brannew",""],
["OP03-094_p1","Air Door",""],
["OP03-110_p1","Charlotte Smoothie",""],
["OP03-116_p6","Shirahoshi",""],
["OP03-121_p1","Thunder Bolt",""],
["OP04-029_p1","Dellinger",""],
["OP04-032_p1","Baby 5",""],
["OP04-036_p1","Donquixote Family",""],
["OP04-056_p1","Gum-Gum Red Roc",""],
["OP04-089_p1","Bartolomeo",""],
["OP04-095_p1","Barrier!!",""],
["OP04-100_p3","Capone\"Gang\"Bege",""],
["OP05-010_p1","Nico Robin",""],
["OP05-015_p2","Belo Betty",""],
["OP05-034_p2","Baby 5",""],
["OP05-057_p1","Hound Blaze",""],
["OP05-073_p1","Miss Doublefinger(Zala)",""],
["OP05-081_p1","One-Legged Toy Soldier",""],
["OP05-082_p1","Shirahoshi",""],
["OP05-105_p1","Satori",""],
["OP05-114_p1","El Thor",""],
["OP05-115_p1","Two-Hundred Million Volts Amaru",""],
["OP05-117_p1","Upper Yard",""],
["OP06-003_p1","Emporio.Ivankov",""],
["OP06-023_p1","Arlong",""],
["OP06-036_p1","Ryuma",""],
["OP06-038_p1","The Billion-fold World Trichiliocosm",""],
["OP06-056_p1","Ama no Murakumo Sword",""],
["OP06-060_p1","Vinsmoke Ichiji",""],
["OP06-064_p1","Vinsmoke Niji",""],
["OP06-065_p1","Vinsmoke Niji",""],
["OP06-066_p1","Vinsmoke Yonji",""],
["OP06-067_p1","Vinsmoke Yonji",""],
["OP06-068_p1","Vinsmoke Reiju",""],
["OP06-079_p1","Kingdom of GERMA",""],
["OP06-091_p1","Victoria Cindry",""],
["OP06-100_p1","Inuarashi",""],
["OP06-110_p2","Nekomamushi",""],
["OP06-114_p1","Wyper",""],
["ST01-006_p6","Tony Tony.Chopper",""],
["ST01-014_p1","Guard Point",""],
["ST02-004_p1","Capone\"Gang\"Bege",""],
["ST03-005_p4","Dracule Mihawk",""],
["ST03-008_p6","Trafalgar Law",""],
["ST03-013_p1","Boa Hancock",""],
["ST04-005_p3","Queen",""],
["ST04-016_p1","Blast Breath",""],
["ST06-010_p1","Helmeppo",""],
["ST06-014_p1","Shockwave",""],
["ST07-007_p2","Charlotte Brulee",""],
["ST09-014_p1","Narikabura Arrow",""],
["ST12-014_p1","Duval",""],
["P-014_p1","Koby",""],
["P-029_p2","Bartolomeo",""],
["P-053_p1","Nami",""],
["P-055_p1","Monkey.D.Luffy",""],
["OP01-006_p4","Otama",""],
["OP01-033_p5","Izo",""],
["OP01-041_p5","Kouzuki Momonosuke",""],
["OP01-052_p4","Raizo",""],
["OP02-015_p3","Makino",""],
["OP02-018_p5","Marco",""],
["OP02-106_p4","Tsuru",""],
["OP03-003_p3","Izo",""],
["OP03-060_p2","Kalifa",""],
["OP03-079_p2","Vergo",""],
["OP03-089_p3","Brannew",""],
["OP03-110_p2","Charlotte Smoothie",""],
["OP03-116_p7","Shirahoshi",""],
["OP04-029_p2","Dellinger",""],
["OP04-032_p2","Baby 5",""],
["OP04-089_p2","Bartolomeo",""],
["OP04-100_p4","Capone\"Gang\"Bege",""],
["OP05-010_p2","Nico Robin",""],
["OP05-015_p3","Belo Betty",""],
["OP05-034_p3","Baby 5",""],
["OP05-073_p2","Miss Doublefinger(Zala)",""],
["OP05-081_p2","One-Legged Toy Soldier",""],
["OP05-082_p2","Shirahoshi",""],
["OP05-105_p2","Satori",""],
["OP06-003_p2","Emporio.Ivankov",""],
["OP06-023_p2","Arlong",""],
["OP06-036_p2","Ryuma",""],
["OP06-060_p2","Vinsmoke Ichiji",""],
["OP06-064_p2","Vinsmoke Niji",""],
["OP06-065_p2","Vinsmoke Niji",""],
["OP06-066_p2","Vinsmoke Yonji",""],
["OP06-067_p2","Vinsmoke Yonji",""],
["OP06-068_p2","Vinsmoke Reiju",""],
["OP06-091_p2","Victoria Cindry",""],
["OP06-100_p2","Inuarashi",""],
["OP06-110_p3","Nekomamushi",""],
["OP06-114_p2","Wyper",""],
["ST01-006_p7","Tony Tony.Chopper",""],
["ST02-004_p2","Capone\"Gang\"Bege",""],
["ST03-005_p5","Dracule Mihawk",""],
["ST03-008_p7","Trafalgar Law",""],
["ST03-013_p2","Boa Hancock",""],
["ST04-005_p4","Queen",""],
["ST06-010_p2","Helmeppo",""],
["ST07-007_p3","Charlotte Brulee",""],
["ST12-014_p2","Duval",""],
["P-014_p2","Koby",""],
["P-029_p3","Bartolomeo",""],
["P-053_p2","Nami",""],
["P-055_p2","Monkey.D.Luffy",""],
["OP01-029_p2","Radical Beam!!",""],
["OP02-089_p2","Judgment of Hell",""],
["OP02-117_p2","Ice Age",""],
["OP03-055_p2","Gum-Gum Giant Gavel",""],
["OP03-056_p2","Sanji's Pilaf",""],
["OP03-057_p2","Three Thousand Worlds",""],
["OP03-094_p2","Air Door",""],
["OP03-121_p2","Thunder Bolt",""],
["OP04-036_p2","Donquixote Family",""],
["OP04-056_p2","Gum-Gum Red Roc",""],
["OP04-095_p2","Barrier!!",""],
["OP05-057_p2","Hound Blaze",""],
["OP05-114_p2","El Thor",""],
["OP05-115_p2","Two-Hundred Million Volts Amaru",""],
["OP05-117_p2","Upper Yard",""],
["OP06-038_p2","The Billion-fold World Trichiliocosm",""],
["OP06-056_p2","Ama no Murakumo Sword",""],
["OP06-079_p2","Kingdom of GERMA",""],
["ST01-014_p2","Guard Point",""],
["ST04-016_p2","Blast Breath",""],
["ST06-014_p2","Shockwave",""],
["ST09-014_p2","Narikabura Arrow",""],
["OP01-006_p5","Otama",""],
["OP01-024_p2","Monkey.D.Luffy",""],
["OP01-033_p6","Izo",""],
["OP01-041_p6","Kouzuki Momonosuke",""],
["OP01-047_p3","Trafalgar Law",""],
["OP01-051_p3","Eustass\"Captain\"Kid",""],
["OP01-070_p3","Dracule Mihawk",""],
["OP01-078_p3","Boa Hancock",""],
["OP01-120_p4","Shanks",""],
["OP01-121_p4","Yamato",""],
["OP02-004_p4","Edward.Newgate",""],
["OP02-018_p6","Marco",""],
["OP02-089_p3","Judgment of Hell",""],
["OP02-096_p3","Kuzan",""],
["OP02-099_p4","Sakazuki",""],
["OP02-114_p3","Borsalino",""],
["OP02-121_p2","Kuzan",""],
["OP03-003_p4","Izo",""],
["OP03-056_p3","Sanji's Pilaf",""],
["OP03-057_p3","Three Thousand Worlds",""],
["OP03-089_p4","Brannew",""],
["OP03-108_p2","Charlotte Cracker",""],
["OP03-110_p3","Charlotte Smoothie",""],
["OP03-113_p2","Charlotte Perospero",""],
["OP03-123_p3","Charlotte Katakuri",""],
["OP04-031_p2","Donquixote Doflamingo",""],
["OP04-044_p3","Kaido",""],
["OP04-056_p3","Gum-Gum Red Roc",""],
["OP04-089_p3","Bartolomeo",""],
["OP04-100_p5","Capone\"Gang\"Bege",""],
["OP04-104_p2","Sanji",""],
["OP04-112_p3","Yamato",""],
["OP05-006_p2","Koala",""],
["OP05-007_p2","Sabo",""],
["OP05-015_p4","Belo Betty",""],
["OP05-034_p4","Baby 5",""],
["OP05-043_p2","Ulti",""],
["OP05-057_p3","Hound Blaze",""],
["OP05-074_p4","Eustass\"Captain\"Kid",""],
["OP05-081_p3","One-Legged Toy Soldier",""],
["OP05-082_p3","Shirahoshi",""],
["OP05-105_p3","Satori",""],
["OP05-115_p3","Two-Hundred Million Volts Amaru",""],
["OP05-117_p3","Upper Yard",""],
["OP05-118_p2","Kaido",""],
["OP05-119_p4","Monkey.D.Luffy",""],
["OP06-023_p3","Arlong",""],
["OP06-035_p2","Hody Jones",""],
["OP06-036_p3","Ryuma",""],
["OP06-065_p3","Vinsmoke Niji",""],
["OP06-067_p3","Vinsmoke Yonji",""],
["OP06-069_p2","Vinsmoke Reiju",""],
["OP06-079_p3","Kingdom of GERMA",""],
["OP06-086_p2","Gecko Moria",""],
["OP06-106_p2","Kouzuki Hiyori",""],
["ST01-006_p8","Tony Tony.Chopper",""],
["ST02-004_p3","Capone\"Gang\"Bege",""],
["ST03-013_p3","Boa Hancock",""],
["ST04-003_p6","Kaido",""],
["ST10-010_p3","Trafalgar Law",""],
["OP01-016_p7","Nami",""],
["PRB02-001","Koby","Rare"],
["PRB02-002","Trafalgar Law","Super Rare"],
["PRB02-003","Lucky.Roux","Rare"],
["PRB02-004","Jewelry Bonney","Rare"],
["PRB02-005","Monkey.D.Luffy","Super Rare"],
["PRB02-006","Roronoa Zoro","Rare"],
["PRB02-007","Jinbe","Rare"],
["PRB02-008","Marco","Super Rare"],
["PRB02-009","Mr.3(Galdino)","Rare"],
["PRB02-010","Charlotte Pudding","Super Rare"],
["PRB02-011","Donquixote Doflamingo","Rare"],
["PRB02-012","Nami","Rare"],
["PRB02-013","Gecko Moria","Rare"],
["PRB02-014","Sabo","Super Rare"],
["PRB02-015","Shiryu","Rare"],
["PRB02-016","Otama","Rare"],
["PRB02-017","Boa Hancock","Super Rare"],
["PRB02-018","Portgas.D.Ace","Rare"],
["ST01-011","Brook","Common"],
["ST02-007","Jewelry Bonney","Common"],
["ST06-008","Hina","Common"],
["ST10-005","Jinbe","Common"],
["ST10-008","Shachi & Penguin","Common"],
["ST12-005","Perona","Common"],
["ST12-017","Plastic Surgery Shot","Common"],
["ST13-004","Edward.Newgate","Common"],
["ST13-007","Sabo","Common"],
["ST13-010","Portgas.D.Ace","Common"],
["ST13-014","Monkey.D.Luffy","Common"],
["ST13-019","The Three Brothers' Bond","Common"],
["ST14-007","Nico Robin","Common"],
["ST14-010","Brook","Common"],
["ST14-013","Roronoa Zoro","Common"],
["ST14-016","I Have My Crew!!","Common"],
["ST14-017","Thousand Sunny","Common"],
["ST15-002","Edward.Newgate","Super Rare"],
["ST16-003","Charlotte Katakuri","Common"],
["ST16-004","Shanks","Super Rare"],
["ST16-005","Monkey.D.Luffy","Common"],
["ST17-002","Trafalgar Law","Super Rare"],
["ST17-003","Buggy","Common"],
["ST17-005","Marshall.D.Teach","Common"],
["ST18-001","Uso-Hachi","Common"],
["ST18-002","O-Nami","Common"],
["ST18-003","San-Gorou","Common"],
["ST19-002","Sengoku","Common"],
["ST20-003","Charlotte Brulee","Common"],
["ST21-003","Sanji","Common"],
["P-044_p2","Sabo",""],
["P-063_p2","Jinbe",""],
["P-068_p1","Sanji",""],
["P-069_p2","Koala",""],
["P-070_p2","Carrot",""],
["P-073_p1","Sabo",""],
["P-074_p1","Portgas.D.Ace",""],
["P-075_p1","Monkey.D.Luffy",""],
["P-078_p1","Adio",""],
["P-079_p2","Lim",""],
["P-081_p2","Dracule Mihawk",""],
["P-082_p2","Crocodile",""],
["P-083_p2","Shanks",""],
["P-085_p1","Jewelry Bonney",""],
["P-088_p1","Trafalgar Law",""],
["OP01-039_p3","Killer",""],
["OP01-055_p1","You Can Be My Samurai!!",""],
["OP02-005_p2","Curly.Dadan",""],
["OP03-008_p2","Buggy",""],
["OP03-048_p1","Nojiko",""],
["OP04-077_p1","Ideo",""],
["OP04-096_p1","Corrida Coliseum",""],
["OP05-004_p2","Emporio.Ivankov",""],
["OP05-021_p1","Revolutionary Army HQ",""],
["OP05-036_p3","Monet",""],
["OP05-052_p1","Maynard",""],
["OP05-077_p1","Gamma Knife",""],
["OP05-097_p1","Mary Geoise",""],
["OP06-044_p1","Gion",""],
["OP06-049_p1","Sengoku",""],
["OP06-056_p3","Ama no Murakumo Sword",""],
["OP06-059_p1","White Snake",""],
["OP06-063_p1","Vinsmoke Sora",""],
["OP06-073_p1","Shiki",""],
["OP06-076_p4","Hitokiri Kamazo",""],
["OP06-078_p1","GERMA 66",""],
["OP07-014_p1","Moda",""],
["OP07-017_p1","Dragon Breath",""],
["OP07-031_p1","Bartolomeo",""],
["OP07-040_p1","Crocodile",""],
["OP07-056_p1","Slave Arrow",""],
["OP07-076_p1","Slow-Slow Beam Sword",""],
["OP07-114_p1","He Possesses the World's Most Brilliant Mind",""],
["OP08-076_p1","It's to Die For...",""],
["OP08-087_p1","Scratchmen Apoo",""],
["OP08-099_p1","Kalgara",""],
["OP09-014_p1","Limejuice",""],
["OP09-027_p1","Sabo",""],
["OP09-033_p1","Nico Robin",""],
["OP09-077_p1","Gum-Gum Lightning",""],
["OP09-079_p1","Gum-Gum Jump Rope",""],
["OP09-084_p1","Catarina Devon",""],
["OP09-097_p1","Black Vortex",""],
["OP09-098_p1","Black Hole",""],
["OP10-018_p1","Ten-Layer Igloo",""],
["OP10-079_p1","God Thread",""],
["OP10-105_p1","Cavendish",""],
["OP10-108_p1","Scratchmen Apoo",""],
["OP10-114_p1","X.Drake",""],
["ST01-011_p7","Brook",""],
["ST02-007_p5","Jewelry Bonney",""],
["ST06-008_p2","Hina",""],
["ST10-005_p2","Jinbe",""],
["ST10-008_p1","Shachi & Penguin",""],
["ST12-005_p1","Perona",""],
["ST12-017_p1","Plastic Surgery Shot",""],
["ST13-004_p2","Edward.Newgate",""],
["ST13-007_p2","Sabo",""],
["ST13-010_p2","Portgas.D.Ace",""],
["ST13-014_p2","Monkey.D.Luffy",""],
["ST13-019_p1","The Three Brothers' Bond",""],
["ST14-007_p1","Nico Robin",""],
["ST14-010_p1","Brook",""],
["ST14-013_p1","Roronoa Zoro",""],
["ST14-016_p1","I Have My Crew!!",""],
["ST14-017_p1","Thousand Sunny",""],
["ST16-003_p1","Charlotte Katakuri",""],
["ST16-005_p1","Monkey.D.Luffy",""],
["ST17-003_p2","Buggy",""],
["ST17-005_p1","Marshall.D.Teach",""],
["ST18-001_p2","Uso-Hachi",""],
["ST18-002_p1","O-Nami",""],
["ST18-003_p2","San-Gorou",""],
["ST19-002_p3","Sengoku",""],
["ST20-003_p1","Charlotte Brulee",""],
["ST21-003_p2","Sanji",""],
["EB01-009_p1","Just Shut Up and Come with Us!!!!",""],
["EB01-018_p1","Mountain God",""],
["EB01-038_p1","Oh Come My Way",""],
["EB01-060_p1","Did Someone Say...Kami?",""],
["P-044_p3","Sabo",""],
["P-063_p3","Jinbe",""],
["P-068_p2","Sanji",""],
["P-069_p3","Koala",""],
["P-070_p3","Carrot",""],
["P-073_p2","Sabo",""],
["P-074_p2","Portgas.D.Ace",""],
["P-075_p2","Monkey.D.Luffy",""],
["P-078_p2","Adio",""],
["P-079_p3","Lim",""],
["P-081_p3","Dracule Mihawk",""],
["P-082_p3","Crocodile",""],
["P-083_p3","Shanks",""],
["P-085_p2","Jewelry Bonney",""],
["P-088_p2","Trafalgar Law",""],
["PRB02-001_p1","Koby",""],
["PRB02-002_p1","Trafalgar Law",""],
["PRB02-003_p1","Lucky.Roux",""],
["PRB02-004_p1","Jewelry Bonney",""],
["PRB02-005_p1","Monkey.D.Luffy",""],
["PRB02-006_p1","Roronoa Zoro",""],
["PRB02-007_p1","Jinbe",""],
["PRB02-008_p1","Marco",""],
["PRB02-009_p1","Mr.3(Galdino)",""],
["PRB02-010_p1","Charlotte Pudding",""],
["PRB02-011_p1","Donquixote Doflamingo",""],
["PRB02-012_p1","Nami",""],
["PRB02-013_p1","Gecko Moria",""],
["PRB02-014_p1","Sabo",""],
["PRB02-015_p1","Shiryu",""],
["PRB02-016_p1","Otama",""],
["PRB02-017_p1","Boa Hancock",""],
["PRB02-018_p1","Portgas.D.Ace",""],
["OP02-068_p1","Gum-Gum Rain",""],
["OP03-072_p1","Gum-Gum Jet Gatling",""],
["OP04-016_p1","Bad Manners Kick Course",""],
["OP05-030_p2","Donquixote Rosinante",""],
["OP05-097_p2","Mary Geoise",""],
["OP06-058_p1","Gravity Blade Raging Tiger",""],
["OP06-115_p1","You're the One Who Should Disappear.",""],
["OP07-021_p3","Urouge",""],
["OP07-040_p2","Crocodile",""],
["OP09-014_p2","Limejuice",""],
["OP09-056_p1","Mr.3(Galdino)",""],
["OP09-076_p2","Roronoa Zoro",""],
["OP09-086_p1","Jesus Burgess",""],
["OP10-011_p1","Tony Tony.Chopper",""],
["OP10-095_p1","Roronoa Zoro",""],
["OP10-109_p1","Basil Hawkins",""],
["OP10-114_p2","X.Drake",""],
["ST15-002_p2","Edward.Newgate",""],
["ST16-004_p2","Shanks",""],
["ST17-002_p1","Trafalgar Law",""],
["ST18-001_p3","Uso-Hachi",""],
["EB01-015_p4","Scratchmen Apoo",""],
["EB01-051_p1","Finger Pistol",""],
["P-063_p4","Jinbe",""],
["OP06-119_p3","Sanji",""],
["OP06-007_p2","Shanks","Special Card"],
["OP08-023_p2","Carrot","Special Card"],
["OP06-047_p4","Charlotte Pudding","Special Card"],
["EB02-061_p3","Monkey.D.Luffy","Special Card"],
["OP05-091_p4","Rebecca","Special Card"],
["OP10-119_p3","Trafalgar Law","Special Card"],
["OP09-020_p1","Come On!! We'll Fight You!!","Special Card"],
["OP09-057_p1","Cross Guild","Special Card"],
["OP09-078_p1","Gum-Gum Giant","Special Card"],
["OP09-096_p1","My Era...Begins!!","Special Card"],
["ST01-001","Monkey.D.Luffy","Leader"],
["ST01-002","Usopp","Common"],
["ST01-003","Karoo","Common"],
["ST01-004","Sanji","Common"],
["ST01-005","Jinbe","Common"],
["ST01-007","Nami","Common"],
["ST01-008","Nico Robin","Common"],
["ST01-009","Nefeltari Vivi","Common"],
["ST01-010","Franky","Common"],
["ST01-012","Monkey.D.Luffy","Super Rare"],
["ST01-013","Roronoa Zoro","Super Rare"],
["ST01-015","Gum-Gum Jet Pistol","Common"],
["ST01-016","Diable Jambe","Common"],
["ST01-017","Thousand Sunny","Common"],
["ST02-001","Eustass\"Captain\"Kid","Leader"],
["ST02-002","Vito","Common"],
["ST02-003","Urouge","Common"],
["ST02-005","Killer","Common"],
["ST02-006","Koby","Common"],
["ST02-008","Scratchmen Apoo","Common"],
["ST02-009","Trafalgar Law","Super Rare"],
["ST02-010","Basil Hawkins","Common"],
["ST02-011","Heat","Common"],
["ST02-012","Bepo","Common"],
["ST02-013","Eustass\"Captain\"Kid","Super Rare"],
["ST02-014","X.Drake","Common"],
["ST02-015","Scalpel","Common"],
["ST02-016","Repel","Common"],
["ST02-017","Straw Sword","Common"],
["ST03-001","Crocodile","Leader"],
["ST03-002","Edward Weevil","Common"],
["ST03-003","Crocodile","Super Rare"],
["ST03-004","Gecko Moria","Common"],
["ST03-006","Jinbe","Common"],
["ST03-007","Sentomaru","Common"],
["ST03-009","Donquixote Doflamingo","Super Rare"],
["ST03-010","Bartholomew Kuma","Common"],
["ST03-011","Buggy","Common"],
["ST03-012","Pacifista","Common"],
["ST03-014","Marshall.D.Teach","Common"],
["ST03-015","Sables","Common"],
["ST03-016","Thrust Pad Cannon","Common"],
["ST03-017","Love-Love Mellow","Common"],
["ST04-001","Kaido","Leader"],
["ST04-002","Ulti","Common"],
["ST04-004","King","Super Rare"],
["ST04-006","Sasaki","Common"],
["ST04-007","Sheepshead","Common"],
["ST04-008","Jack","Common"],
["ST04-009","Ginrummy","Common"],
["ST04-010","Who's.Who","Common"],
["ST04-011","Black Maria","Common"],
["ST04-012","Page One","Common"],
["ST04-013","X.Drake","Common"],
["ST04-014","Lead Performer \"Disaster\"","Common"],
["ST04-015","Brachio Bomber","Common"],
["ST04-017","Onigashima Island","Common"],
["ST05-001","Shanks","Leader"],
["ST05-002","Ain","Common"],
["ST05-003","Ann","Common"],
["ST05-004","Uta","Super Rare"],
["ST05-005","Carina","Common"],
["ST05-006","Gild Tesoro","Common"],
["ST05-007","Gordon","Common"],
["ST05-008","Shiki","Common"],
["ST05-009","Scarlet","Common"],
["ST05-010","Zephyr","Common"],
["ST05-011","Douglas Bullet","Super Rare"],
["ST05-012","Baccarat","Common"],
["ST05-013","Bins","Common"],
["ST05-014","Buena Festa","Common"],
["ST05-015","Dr. Indigo","Common"],
["ST05-016","Lion's Threat Imperial Earth Bind","Common"],
["ST05-017","Union Armada","Common"],
["ST06-001","Sakazuki","Leader"],
["ST06-002","Koby","Common"],
["ST06-003","Jango","Common"],
["ST06-004","Smoker","Super Rare"],
["ST06-005","Sengoku","Common"],
["ST06-006","Tashigi","Common"],
["ST06-007","Tsuru","Common"],
["ST06-009","Fullbody","Common"],
["ST06-011","Momonga","Common"],
["ST06-012","Monkey.D.Garp","Super Rare"],
["ST06-013","T-Bone","Common"],
["ST06-015","Great Eruption","Common"],
["ST06-016","White Out","Common"],
["ST06-017","Navy HQ","Common"],
["ST07-001","Charlotte Linlin","Leader"],
["ST07-002","Charlotte Anana","Common"],
["ST07-003","Charlotte Katakuri","Super Rare"],
["ST07-004","Charlotte Snack","Common"],
["ST07-005","Charlotte Daifuku","Common"],
["ST07-006","Charlotte Flampe","Common"],
["ST07-008","Charlotte Pudding","Common"],
["ST07-009","Charlotte Mont-d'or","Common"],
["ST07-010","Charlotte Linlin","Super Rare"],
["ST07-011","Zeus","Common"],
["ST07-012","Baron Tamago","Common"],
["ST07-013","Prometheus","Common"],
["ST07-014","Pekoms","Common"],
["ST07-015","Soul Pocus","Common"],
["ST07-016","Power Mochi","Common"],
["ST07-017","Queen Mama Chanter","Common"],
["ST08-001","Monkey.D.Luffy","Leader"],
["ST08-002","Uta","Super Rare"],
["ST08-003","Gaimon","Common"],
["ST08-004","Koby","Common"],
["ST08-005","Shanks","Super Rare"],
["ST08-006","Shirahoshi","Common"],
["ST08-007","Nefeltari Vivi","Common"],
["ST08-008","Higuma","Common"],
["ST08-009","Makino","Common"],
["ST08-010","Monkey.D.Garp","Common"],
["ST08-011","Monkey.D.Luffy","Common"],
["ST08-012","Laboon","Common"],
["ST08-013","Mr.2.Bon.Kurei(Bentham)","Common"],
["ST08-014","Gum-Gum Bell","Common"],
["ST08-015","Gum-Gum Pistol","Common"],
["ST09-001","Yamato","Leader"],
["ST09-002","Uzuki Tempura","Common"],
["ST09-003","Ulti","Common"],
["ST09-004","Kaido","Common"],
["ST09-005","Kouzuki Oden","Super Rare"],
["ST09-006","Kouzuki Momonosuke","Common"],
["ST09-007","Shinobu","Common"],
["ST09-008","Shimotsuki Ushimaru","Common"],
["ST09-009","Fugetsu Omusubi","Common"],
["ST09-010","Portgas.D.Ace","Super Rare"],
["ST09-011","Monkey.D.Luffy","Common"],
["ST09-012","Yamato","Common"],
["ST09-013","Yamato","Common"],
["ST09-015","Thunder Bagua","Common"],
["ST10-001","Trafalgar Law","Leader"],
["ST10-002","Monkey.D.Luffy","Leader"],
["ST10-003","Eustass\"Captain\"Kid","Leader"],
["OP01-016_p3","Nami",""],
["OP01-025_p3","Roronoa Zoro",""],
["ST10-004","Sanji","Common"],
["ST10-006","Monkey.D.Luffy","Super Rare"],
["ST10-007","Killer","Common"],
["ST10-009","Jean Bart","Common"],
["ST10-011","Heat","Common"],
["ST10-012","Bepo","Common"],
["ST10-013","Eustass\"Captain\"Kid","Super Rare"],
["ST10-014","Wire","Common"],
["ST10-015","Gum-Gum Giant Sumo Slap","Common"],
["ST10-016","Gum-Gum Kong Gatling","Common"],
["ST10-017","Punk Vise","Common"],
["ST11-001","Uta","Leader"],
["ST11-002","Uta","Super Rare"],
["ST11-003","Backlight","Common"],
["ST11-004","New Genesis","Super Rare"],
["ST11-005","I'm invincible","Common"],
["ST12-001","Roronoa Zoro & Sanji","Leader"],
["ST12-002","Kuina","Common"],
["ST12-003","Dracule Mihawk","Super Rare"],
["ST12-004","Humandrill","Common"],
["ST12-006","Yosaku & Johnny","Common"],
["ST12-007","Rika","Common"],
["ST12-008","Roronoa Zoro","Common"],
["ST12-009","Elephant True Bluefin","Common"],
["ST12-010","Emporio.Ivankov","Super Rare"],
["ST12-011","Sanji","Common"],
["ST12-012","Charlotte Pudding","Common"],
["ST12-013","Zeff","Common"],
["ST12-015","Patty & Carne","Common"],
["ST12-016","Lion Strike","Common"],
["ST13-001","Sabo","Leader"],
["ST13-002","Portgas.D.Ace","Leader"],
["ST13-003","Monkey.D.Luffy","Leader"],
["ST13-005","Emporio.Ivankov","Rare"],
["ST13-006","Curly.Dadan","Common"],
["ST13-008","Sabo","Super Rare"],
["ST13-009","Shanks","Common"],
["ST13-011","Portgas.D.Ace","Super Rare"],
["ST13-012","Makino","Common"],
["ST13-013","Monkey.D.Garp","Super Rare"],
["ST13-015","Monkey.D.Luffy","Super Rare"],
["ST13-016","Yamato","Common"],
["ST13-017","Flame Dragon King","Common"],
["ST13-018","Gum-Gum Jet Spear","Common"],
["ST13-001_p1","Sabo",""],
["ST13-002_p1","Portgas.D.Ace",""],
["ST13-003_p1","Monkey.D.Luffy",""],
["ST13-004_p1","Edward.Newgate",""],
["ST13-005_p1","Emporio.Ivankov",""],
["ST13-006_p1","Curly.Dadan",""],
["ST13-007_p1","Sabo",""],
["ST13-008_p1","Sabo",""],
["ST13-009_p1","Shanks",""],
["ST13-010_p1","Portgas.D.Ace",""],
["ST13-011_p1","Portgas.D.Ace",""],
["ST13-012_p1","Makino",""],
["ST13-013_p1","Monkey.D.Garp",""],
["ST13-014_p1","Monkey.D.Luffy",""],
["ST13-015_p1","Monkey.D.Luffy",""],
["ST13-016_p1","Yamato",""],
["OP02-001_p2","Edward.Newgate","Leader"],
["ST15-001","Atmos","Common"],
["ST15-003","Kingdew","Common"],
["ST15-004","Thatch","Common"],
["ST15-005","Portgas.D.Ace","Super Rare"],
["ST11-001_p1","Uta","Leader"],
["ST16-001","Uta","Super Rare"],
["ST16-002","Gordon","Common"],
["ST11-003_p2","Backlight","Common"],
["ST11-004_p2","New Genesis","Super Rare"],
["ST11-005_p2","I'm invincible","Common"],
["P-057_p1","Fleeting Lullaby",""],
["P-058_p1","Where the Wind Blows",""],
["P-059_p1","The World's Continuation",""],
["P-060_p1","Tot Musica",""],
["P-061","Monkey.D.Luffy",""],
["OP01-060_p2","Donquixote Doflamingo","Leader"],
["ST17-001","Crocodile","Common"],
["ST17-004","Boa Hancock","Super Rare"],
["P-030","Jinbe",""],
["OP05-060_p3","Monkey.D.Luffy","Leader"],
["ST18-004","Zoro-Juurou","Super Rare"],
["ST18-005","Luffy-Tarou","Super Rare"],
["P-041","Monkey.D.Luffy",""],
["OP02-093_p2","Smoker","Leader"],
["ST19-001","Smoker","Common"],
["ST19-003","Tashigi","Super Rare"],
["ST19-004","Hina","Super Rare"],
["ST19-005","Monkey.D.Garp","Common"],
["OP03-099_p2","Charlotte Katakuri","Leader"],
["ST20-001","Charlotte Katakuri","Super Rare"],
["ST20-002","Charlotte Cracker","Common"],
["ST20-004","Charlotte Pudding","Common"],
["ST20-005","Charlotte Linlin","Super Rare"],
["ST21-001","Monkey.D.Luffy","Leader"],
["ST21-002","Usopp","Common"],
["ST21-004","Jewelry Bonney","Common"],
["ST21-005","Jinbe","Common"],
["ST21-006","Stussy","Common"],
["ST21-007","Sentomaru","Common"],
["ST21-008","Tony Tony.Chopper","Common"],
["ST21-009","Nami","Common"],
["ST21-010","Nico Robin","Common"],
["ST21-011","Franky","Common"],
["ST21-012","Brook","Common"],
["ST21-013","Vegapunk","Common"],
["ST21-014","Monkey.D.Luffy","Super Rare"],
["ST21-015","Roronoa Zoro","Super Rare"],
["ST21-016","Gum-Gum Dawn Whip","Common"],
["ST21-017","Gum-Gum Mole Pistol","Common"],
["ST21-001_p1","Monkey.D.Luffy",""],
["ST21-002_p1","Usopp",""],
["ST21-003_p1","Sanji",""],
["ST21-004_p1","Jewelry Bonney",""],
["ST21-005_p1","Jinbe",""],
["ST21-006_p1","Stussy",""],
["ST21-007_p1","Sentomaru",""],
["ST21-008_p1","Tony Tony.Chopper",""],
["ST21-009_p1","Nami",""],
["ST21-010_p1","Nico Robin",""],
["ST21-011_p1","Franky",""],
["ST21-012_p1","Brook",""],
["ST21-013_p1","Vegapunk",""],
["ST21-014_p1","Monkey.D.Luffy",""],
["ST21-015_p1","Roronoa Zoro",""],
["ST22-001","Ace & Newgate","Leader"],
["ST22-002","Izo","Super Rare"],
["ST22-003","Edward.Newgate","Common"],
["ST22-004","Elmy","Common"],
["ST22-005","Kouzuki Oden","Super Rare"],
["ST22-006","Jozu","Common"],
["ST22-007","Squard","Common"],
["ST22-008","Decalvan Brothers","Common"],
["ST22-009","Vista","Common"],
["ST22-010","Portgas.D.Ace","Common"],
["ST22-011","Whitey Bay","Common"],
["ST22-012","Marco","Common"],
["ST22-013","LittleOars Jr.","Common"],
["ST22-014","A.O.","Common"],
["ST22-015","I Am Whitebeard!!","Common"],
["ST22-016","Take That Back!! Take Back What You Said!!","Common"],
["ST22-017","Fire Fist","Common"],
["ST22-001_p1","Ace & Newgate",""],
["ST22-002_p1","Izo",""],
["ST22-003_p1","Edward.Newgate",""],
["ST22-004_p1","Elmy",""],
["ST22-005_p1","Kouzuki Oden",""],
["ST22-006_p1","Jozu",""],
["ST22-007_p1","Squard",""],
["ST22-008_p1","Decalvan Brothers",""],
["ST22-009_p1","Vista",""],
["ST22-010_p1","Portgas.D.Ace",""],
["ST22-011_p1","Whitey Bay",""],
["ST22-012_p1","Marco",""],
["ST22-013_p1","LittleOars Jr.",""],
["ST22-014_p1","A.O.",""],
["OP09-001_p2","Shanks","Leader"],
["ST23-001","Uta","Super Rare"],
["ST23-002","Shanks","Super Rare"],
["ST23-003","Benn.Beckman","Common"],
["ST23-004","Monkey.D.Luffy","Common"],
["ST23-005","Yasopp","Common"],
["OP07-019_p3","Jewelry Bonney","Leader"],
["ST24-001","Capone\"Gang\"Bege","Common"],
["ST24-002","Kid & Killer","Super Rare"],
["ST24-003","Basil Hawkins","Common"],
["ST24-004","Law & Bepo","Super Rare"],
["ST24-005","X.Drake","Common"],
["OP09-042_p2","Buggy","Leader"],
["ST25-001","Alvida","Common"],
["ST25-002","Cabaji","Common"],
["ST25-003","Crocodile & Mihawk","Super Rare"],
["ST25-004","Buggy","Super Rare"],
["ST25-005","Mohji","Common"],
["P-084","Buggy",""],
["OP09-061_p2","Monkey.D.Luffy","Leader"],
["ST26-001","Soba Mask","Common"],
["ST26-002","Tony Tony.Chopper","Common"],
["ST26-003","Nico Robin","Super Rare"],
["ST26-004","General Franky","Common"],
["ST26-005","Monkey.D.Luffy","Super Rare"],
["OP09-081_p2","Marshall.D.Teach","Leader"],
["ST27-001","Avalo Pizarro","Common"],
["ST27-002","Catarina Devon","Common"],
["ST27-003","Kuzan","Super Rare"],
["ST27-004","Sanjuan.Wolf","Common"],
["ST27-005","Marshall.D.Teach","Super Rare"],
["OP06-022_p3","Yamato","Leader"],
["ST28-001","Ashura Doji","Common"],
["ST28-002","Izo","Common"],
["ST28-003","Kin'emon","Common"],
["ST28-004","Kouzuki Momonosuke","Super Rare"],
["ST28-005","Yamato","Super Rare"],
["ST29-001","Monkey.D.Luffy","Leader"],
["ST29-002","Usopp","Common"],
["ST29-003","Kaku","Common"],
["ST29-004","Sanji","Super Rare"],
["ST29-005","Jinbe","Common"],
["ST29-006","Stussy","Common"],
["ST29-007","Tony Tony.Chopper","Common"],
["ST29-008","Nami","Common"],
["ST29-009","Nico Robin","Common"],
["ST29-010","Franky","Common"],
["ST29-011","Brook","Common"],
["ST29-012","Monkey.D.Luffy","Common"],
["ST29-013","Rob Lucci","Common"],
["ST29-014","Roronoa Zoro","Super Rare"],
["ST29-015","Raw Heat Strike","Common"],
["ST29-016","Kizaru!! Compared to Two Years Ago We're a Hundred Times Stronger Now!!","Common"],
["ST29-017","Iai Death Lion Song","Common"],
["ST29-001_p1","Monkey.D.Luffy",""],
["ST29-002_p1","Usopp",""],
["ST29-003_p1","Kaku",""],
["ST29-004_p1","Sanji",""],
["ST29-005_p1","Jinbe",""],
["ST29-006_p1","Stussy",""],
["ST29-007_p1","Tony Tony.Chopper",""],
["ST29-008_p1","Nami",""],
["ST29-009_p1","Nico Robin",""],
["ST29-010_p1","Franky",""],
["ST29-011_p1","Brook",""],
["ST29-012_p1","Monkey.D.Luffy",""],
["ST29-013_p1","Rob Lucci",""],
["ST29-014_p1","Roronoa Zoro",""],
["ST30-001","Luffy & Ace","Leader"],
["ST30-002","Inazuma","Common"],
["ST30-003","Edward.Newgate","Common"],
["ST30-004","Emporio.Ivankov","Common"],
["ST30-005","Jozu","Common"],
["ST30-006","Jinbe","Common"],
["ST30-007","Portgas.D.Ace","Super Rare"],
["ST30-008","Marco","Common"],
["ST30-009","LittleOars Jr.","Common"],
["ST30-010","Crocodile","Common"],
["ST30-011","Buggy","Common"],
["ST30-012","Monkey.D.Luffy","Super Rare"],
["ST30-013","Mr.2.Bon.Kurei(Bentham)","Common"],
["ST30-014","Mr.3(Galdino)","Common"],
["ST30-015","The Name of This Era Is \"Whitebeard\"!!","Common"],
["ST30-016","Can You Still Fight, Luffy?! Of Course!!","Common"],
["ST30-017","And You Get Yourself in Big Trouble!!","Common"],
["ST30-001_p1","Luffy & Ace",""],
["ST30-002_p1","Inazuma",""],
["ST30-003_p1","Edward.Newgate",""],
["ST30-004_p1","Emporio.Ivankov",""],
["ST30-005_p1","Jozu",""],
["ST30-006_p1","Jinbe",""],
["ST30-007_p1","Portgas.D.Ace",""],
["ST30-008_p1","Marco",""],
["ST30-009_p1","LittleOars Jr.",""],
["ST30-010_p1","Crocodile",""],
["ST30-011_p1","Buggy",""],
["ST30-012_p1","Monkey.D.Luffy",""],
["ST30-013_p1","Mr.2.Bon.Kurei(Bentham)",""],
["ST30-014_p1","Mr.3(Galdino)",""],
["ST30-015_p1","The Name of This Era Is \"Whitebeard\"!!",""],
["ST30-016_p1","Can You Still Fight, Luffy?! Of Course!!",""],
["ST30-017_p1","And You Get Yourself in Big Trouble!!",""],
["ST21-001_p3","Monkey.D.Luffy","Leader"],
["ST31-001","Sanji","Super Rare"],
["ST31-002","Jinbe","Common"],
["ST31-003","Brook","Common"],
["ST31-004","Monkey.D.Luffy","Super Rare"],
["ST31-005","Thousand Sunny","Common"],
["OP12-020_p5","Roronoa Zoro","Leader"],
["ST32-001","Kin'emon","Common"],
["ST32-002","Kouzuki Oden","Super Rare"],
["ST32-003","Dracule Mihawk","Super Rare"],
["ST32-004","Silvers Rayleigh","Common"],
["ST32-005","Roronoa Zoro","Common"],
["OP12-040_p2","Kuzan","Leader"],
["ST33-001","Koby","Common"],
["ST33-002","Sakazuki","Common"],
["ST33-003","Smoker","Common"],
["ST33-004","Borsalino","Super Rare"],
["ST33-005","Monkey.D.Garp","Super Rare"],
["OP11-062_p2","Charlotte Katakuri","Leader"],
["ST34-001","Charlotte Katakuri","Super Rare"],
["ST34-002","Charlotte Cracker","Common"],
["ST34-003","Charlotte Brulee","Common"],
["ST34-004","Charlotte Linlin","Super Rare"],
["ST34-005","Baron Tamago & Pekoms","Common"],
["OP13-004_p2","Sabo","Leader"],
["ST35-001","Hack","Common"],
["ST35-002","Lindbergh","Common"],
["ST35-003","Karasu","Common"],
["ST35-004","Koala","Super Rare"],
["ST35-005","Bartholomew Kuma","Super Rare"],
["OP10-099_p2","Eustass\"Captain\"Kid","Leader"],
["ST36-001","Cavendish","Common"],
["ST36-002","Killer","Super Rare"],
["ST36-003","Scratchmen Apoo","Common"],
["ST36-004","Bartolomeo","Common"],
["ST36-005","Eustass\"Captain\"Kid","Super Rare"]
];

export const OP_CARD_COUNT = ROWS.length;

// Matches on name, and on id so you can paste a code straight in.
/* The suffix in OP13-118_p2 is our convention, borrowed from Limitless. It is
   printed on no card, so nobody would ever type it or recognise it. Everything
   below exists to keep it out of sight. */
export const baseCode = (id) => String(id || "").split("_")[0];

/* What to call a print, given the catalogue tells us almost nothing: rarity is
   blank on 975 of the 1,147 parallels. So the label is honest and generic, and
   the art beside it does the real work of saying which one you're holding. */
export function printLabel(id, rarity) {
  const suffix = (String(id || "").match(/_([pr])(\d+)$/i) || [])[0];
  if (!suffix) return rarity || "Base print";
  const kind = /p/i.test(suffix) ? "Alt art" : "Reprint";
  const n = suffix.replace(/[^0-9]/g, "");
  return rarity ? `${kind} ${n} · ${rarity}` : `${kind} ${n}`;
}

/* Every print sharing a card number, base first. A stack line naming a bare
   code is genuinely ambiguous — OP13-118 has five prints running from $28 to
   $8,490 — so whatever picks one has to be able to show what it passed over. */
export function printsOf(code) {
  const base = baseCode(code);
  return ROWS.filter(([id]) => baseCode(id) === base)
    .map(([id, name, rarity]) => ({ id, name, rarity }))
    .sort((a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }));
}

/* Keeps every print of one card together and in order, without disturbing the
   order the families themselves came back in. A card's prints can differ by
   300x in price, so seeing them side by side is the whole point — split across
   a page boundary they are just five near-identical rows. */
function groupFamilies(list) {
  const families = new Map();
  for (const card of list) {
    const key = baseCode(card.id);
    if (!families.has(key)) families.set(key, []);
    families.get(key).push(card);
  }
  const out = [];
  for (const prints of families.values()) {
    prints.sort((a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }));
    out.push(...prints);
  }
  return out;
}

// Every match, ranked. The search runs on-device against a bundled array, so
// there is nothing to save by stopping early — the old version capped at 60 and
// gave no way to reach the rest, which just hid cards.
function byText(q, only) {
  const starts = [];
  const contains = [];
  for (const [id, name, rarity] of ROWS) {
    if (only && !only.has(setCodeOf(id))) continue;
    const n = name.toLowerCase();
    const i = id.toLowerCase();
    if (n.startsWith(q) || i.startsWith(q)) starts.push({ id, name, rarity });
    else if (n.includes(q) || i.includes(q)) contains.push({ id, name, rarity });
  }
  // Prefix matches first: typing "law" should not bury Law under Lawson.
  return groupFamilies([...starts, ...contains]);
}

/** Every card a set holds, for a query that named a set and nothing else. */
function wholeSets(only) {
  const out = [];
  for (const [id, name, rarity] of ROWS) {
    if (only.has(setCodeOf(id))) out.push({ id, name, rarity });
  }
  return groupFamilies(out);
}

/** OP16-118_p2 → OP16. The set is in the id, which is why codes work with no
 *  set list at all. */
export const setCodeOf = (id) => String(id || "").split("-")[0].toUpperCase();

/**
 * @param sets optional { OP16: { name } } — without it, a set can still be
 *             named by its code, because that is already in every card's id.
 *             With it, "the time of battle luffy" works too.
 */
export function searchOnePiece(query, sets) {
  const q = String(query || "").trim().toLowerCase();
  if (q.length < 2) return [];

  const plain = byText(q);
  if (plain.length) return plain;

  /* Nothing matched a card, so part of it may be a set. Second rather than
     first, exactly as the Pokemon search does it: a set name is not usually
     also a card name, so a query that already found cards was not about a set.
     Codes come from the ids and cost nothing; names need the list. */
  const index = { ...codeIndex(), ...(sets || {}) };
  for (const reading of splitSetPhrase(q, index)) {
    const only = new Set(reading.sets);
    const hits = reading.rest ? byText(reading.rest, only) : wholeSets(only);
    if (hits.length) return hits;
  }
  return [];
}

/* Every code the catalogue actually contains, named after itself. Enough for
   "luffy op16" with no network at all, and it means a set released before the
   name list is refreshed is still reachable. */
let codes = null;
function codeIndex() {
  if (codes) return codes;
  codes = {};
  for (const [id] of ROWS) {
    const code = setCodeOf(id);
    if (code) codes[code] = { name: code };
  }
  return codes;
}
